import { Repository } from "../../entities/github";

// A static cache of repository data if we can't query Github
export const staticRepositoryData: Repository[] = [
  {
    "id": "MDEwOlJlcG9zaXRvcnkzMDkwMTc1",
    "name": "image-search",
    "description": "A hypothetical Dropbox API app that makes it possible to do image searches from Dropbox.",
    "stargazerCount": 36,
    "forkCount": 10,
    "url": "https://github.com/dropbox/image-search",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Haskell",
        "color": "#5e5086"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkzNTY3NjQx",
    "name": "zxcvbn",
    "description": "Low-Budget Password Strength Estimation",
    "stargazerCount": 15745,
    "forkCount": 1002,
    "url": "https://github.com/dropbox/zxcvbn",
    "homepageUrl": "https://www.usenix.org/conference/usenixsecurity16/technical-sessions/presentation/wheeler",
    "languages": [
      {
        "name": "CoffeeScript",
        "color": "#244776"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkzNzc4Mzc1",
    "name": "nautilus-dropbox",
    "description": "Dropbox Integration for Nautilus",
    "stargazerCount": 261,
    "forkCount": 60,
    "url": "https://github.com/dropbox/nautilus-dropbox",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "C",
        "color": "#555555"
      },
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "M4",
        "color": undefined
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk1NDg4NTU4",
    "name": "python-zxcvbn",
    "description": "A realistic password strength estimator.",
    "stargazerCount": 253,
    "forkCount": 55,
    "url": "https://github.com/dropbox/python-zxcvbn",
    "homepageUrl": "https://tech.dropbox.com/2012/04/zxcvbn-realistic-password-strength-estimation/",
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk3MTM5MTY0",
    "name": "pygerduty",
    "description": "A Python library for PagerDuty.",
    "stargazerCount": 165,
    "forkCount": 72,
    "url": "https://github.com/dropbox/pygerduty",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk4Mzg0MDk0",
    "name": "pyxl",
    "description": "A Python extension for writing structured and reusable inline HTML.",
    "stargazerCount": 550,
    "forkCount": 55,
    "url": "https://github.com/dropbox/pyxl",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Emacs Lisp",
        "color": "#c065db"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "Vim Script",
        "color": "#199f4b"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxMDA4Njg2NQ==",
    "name": "librsync",
    "description": "Dropbox modified version of librysnc",
    "stargazerCount": 110,
    "forkCount": 39,
    "url": "https://github.com/dropbox/librsync",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "C",
        "color": "#555555"
      },
      {
        "name": "C++",
        "color": "#f34b7d"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "Objective-C",
        "color": "#438eff"
      },
      {
        "name": "Perl",
        "color": "#0298c3"
      },
      {
        "name": "Standard ML",
        "color": "#dc566d"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxMDk4MzA1MA==",
    "name": "dropbox-sdk-java",
    "description": "A Java library for the Dropbox Core API.",
    "stargazerCount": 623,
    "forkCount": 464,
    "url": "https://github.com/dropbox/dropbox-sdk-java",
    "homepageUrl": "https://www.dropbox.com/developers/documentation/java",
    "languages": [
      {
        "name": "Java",
        "color": "#b07219"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "Kotlin",
        "color": "#A97BFF"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxMTg4NjIwMw==",
    "name": "othw",
    "description": "OAuth 2 the Hard Way - calling the Dropbox API in lots of languages without any Dropbox or OAuth libraries",
    "stargazerCount": 83,
    "forkCount": 27,
    "url": "https://github.com/dropbox/othw",
    "homepageUrl": "",
    "languages": [
      {
        "name": "C#",
        "color": "#178600"
      },
      {
        "name": "ASP",
        "color": "#6a40fd"
      },
      {
        "name": "Go",
        "color": "#00ADD8"
      },
      {
        "name": "Java",
        "color": "#b07219"
      },
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      },
      {
        "name": "PHP",
        "color": "#4F5D95"
      },
      {
        "name": "Perl",
        "color": "#0298c3"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "Ruby",
        "color": "#701516"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxMjY1NTY1Mg==",
    "name": "json11",
    "description": "A tiny JSON library for C++11.",
    "stargazerCount": 2581,
    "forkCount": 623,
    "url": "https://github.com/dropbox/json11",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "C++",
        "color": "#f34b7d"
      },
      {
        "name": "CMake",
        "color": "#DA3434"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxMjcxNTAwOQ==",
    "name": "hydra",
    "description": "A multi-process MongoDB collection copier.",
    "stargazerCount": 317,
    "forkCount": 43,
    "url": "https://github.com/dropbox/hydra",
    "homepageUrl": "https://tech.dropbox.com/2013/09/scaling-mongodb-at-mailbox/",
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxMjgxOTI2NQ==",
    "name": "dropbox-ios-dropins-sdk",
    "description": "An iOS library for choosing files in Dropbox.",
    "stargazerCount": 37,
    "forkCount": 23,
    "url": "https://github.com/dropbox/dropbox-ios-dropins-sdk",
    "homepageUrl": "https://www.dropbox.com/developers/dropins/chooser/ios",
    "languages": [
      {
        "name": "Objective-C",
        "color": "#438eff"
      },
      {
        "name": "C++",
        "color": "#f34b7d"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxMjg1NjE2Nw==",
    "name": "emmer",
    "description": "A python framework for dynamic tftp servers.",
    "stargazerCount": 16,
    "forkCount": 8,
    "url": "https://github.com/dropbox/emmer",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxMjk4NzYxMg==",
    "name": "changes",
    "description": "A dashboard for your code. A build system.",
    "stargazerCount": 749,
    "forkCount": 56,
    "url": "https://github.com/dropbox/changes",
    "homepageUrl": "",
    "languages": [
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      },
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "Mako",
        "color": "#7e858d"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      },
      {
        "name": "CSS",
        "color": "#663399"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxNDk0NjcwOA==",
    "name": "pem-converter-maven-plugin",
    "description": "A Maven plugin that converts OpenSSL-format PEM certificate files to Java-compatible JKS files.",
    "stargazerCount": 7,
    "forkCount": 6,
    "url": "https://github.com/dropbox/pem-converter-maven-plugin",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "Java",
        "color": "#b07219"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxNTA5NzU2OA==",
    "name": "questions",
    "description": "Simple application for storing interview questions.",
    "stargazerCount": 27,
    "forkCount": 8,
    "url": "https://github.com/dropbox/questions",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "CoffeeScript",
        "color": "#244776"
      },
      {
        "name": "CSS",
        "color": "#663399"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxNTY4OTQ2MA==",
    "name": "amqp-coffee",
    "description": "An AMQP 0.9.1 client for Node.js.",
    "stargazerCount": 78,
    "forkCount": 30,
    "url": "https://github.com/dropbox/amqp-coffee",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "CoffeeScript",
        "color": "#244776"
      },
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxNTk1MzczNg==",
    "name": "phabricator-changes",
    "description": "Integration between Phabricator and Changes.  This repository is no longer maintained.",
    "stargazerCount": 19,
    "forkCount": 7,
    "url": "https://github.com/dropbox/phabricator-changes",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "PHP",
        "color": "#4F5D95"
      },
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxNjQzMTEzMg==",
    "name": "PyHive",
    "description": "Python interface to Hive and Presto. 🐝",
    "stargazerCount": 1687,
    "forkCount": 554,
    "url": "https://github.com/dropbox/PyHive",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "Java",
        "color": "#b07219"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWNoaXZl",
        "name": "hive"
      },
      {
        "id": "MDU6VG9waWNweXRob24=",
        "name": "python"
      },
      {
        "id": "MDU6VG9waWNoaXZlc2VydmVyMg==",
        "name": "hiveserver2"
      },
      {
        "id": "MDU6VG9waWNwcmVzdG8=",
        "name": "presto"
      },
      {
        "id": "MDU6VG9waWNkYmFwaQ==",
        "name": "dbapi"
      },
      {
        "id": "MDU6VG9waWNzcWxhbGNoZW15",
        "name": "sqlalchemy"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxNjY4NzY5OA==",
    "name": "zxcvbn-ios",
    "description": "A realistic password strength estimator.",
    "stargazerCount": 224,
    "forkCount": 64,
    "url": "https://github.com/dropbox/zxcvbn-ios",
    "homepageUrl": "https://tech.dropbox.com/2012/04/zxcvbn-realistic-password-strength-estimation/",
    "languages": [
      {
        "name": "Objective-C",
        "color": "#438eff"
      },
      {
        "name": "Ruby",
        "color": "#701516"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxNjc4NTI3Ng==",
    "name": "puppet-osx_ard",
    "description": "A Module for managing Apple Remote Desktop access on OS X.",
    "stargazerCount": 8,
    "forkCount": 7,
    "url": "https://github.com/dropbox/puppet-osx_ard",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Puppet",
        "color": "#302B6D"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxNjk1OTQ3MQ==",
    "name": "puppet-osx_utils",
    "description": "Puppet Module that contains some handy OS X Specific Types.",
    "stargazerCount": 4,
    "forkCount": 7,
    "url": "https://github.com/dropbox/puppet-osx_utils",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Puppet",
        "color": "#302B6D"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxNzQ2MjQ5MQ==",
    "name": "oid_translate",
    "description": "Python Bindings around net-snmp for OID/MIB Name Translations.",
    "stargazerCount": 3,
    "forkCount": 5,
    "url": "https://github.com/dropbox/oid_translate",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "C",
        "color": "#555555"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxNzg3MzQzNQ==",
    "name": "trapperkeeper",
    "description": "A suite of tools for ingesting and displaying SNMP traps.",
    "stargazerCount": 80,
    "forkCount": 23,
    "url": "https://github.com/dropbox/trapperkeeper",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "CSS",
        "color": "#663399"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxODA4ODIxMA==",
    "name": "miniutf",
    "description": "A C++ library for basic Unicode manipulation.",
    "stargazerCount": 122,
    "forkCount": 19,
    "url": "https://github.com/dropbox/miniutf",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "C++",
        "color": "#f34b7d"
      },
      {
        "name": "C",
        "color": "#555555"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxODU0NDY3Mg==",
    "name": "encfs",
    "description": " EncFS Encrypted Filesystem",
    "stargazerCount": 39,
    "forkCount": 11,
    "url": "https://github.com/dropbox/encfs",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "C++",
        "color": "#f34b7d"
      },
      {
        "name": "C",
        "color": "#555555"
      },
      {
        "name": "Perl",
        "color": "#0298c3"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxOTQ3OTIxNA==",
    "name": "pytest-call-tracer",
    "description": undefined,
    "stargazerCount": 9,
    "forkCount": 5,
    "url": "https://github.com/dropbox/pytest-call-tracer",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxOTY2ODgyNA==",
    "name": "mdwebhook",
    "description": "A sample app that uses webhooks to convert Markdown files to HTML.",
    "stargazerCount": 146,
    "forkCount": 52,
    "url": "https://github.com/dropbox/mdwebhook",
    "homepageUrl": "https://mdwebhook.herokuapp.com",
    "languages": [
      {
        "name": "CSS",
        "color": "#663399"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxOTc5MzQ5NQ==",
    "name": "dropbox_hook",
    "description": "A tool for testing your Dropbox webhook endpoints.",
    "stargazerCount": 23,
    "forkCount": 12,
    "url": "https://github.com/dropbox/dropbox_hook",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkyMDIzMjg5Nw==",
    "name": "phabricator-sentry",
    "description": "Sentry integration for Phabricator",
    "stargazerCount": 6,
    "forkCount": 6,
    "url": "https://github.com/dropbox/phabricator-sentry",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "PHP",
        "color": "#4F5D95"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkyMTAyMDc1OQ==",
    "name": "presto-kafka-connector",
    "description": "a presto connector for kafka",
    "stargazerCount": 8,
    "forkCount": 12,
    "url": "https://github.com/dropbox/presto-kafka-connector",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Java",
        "color": "#b07219"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkyMTEwODIxOQ==",
    "name": "godropbox",
    "description": "Common libraries for writing Go services/applications.",
    "stargazerCount": 4202,
    "forkCount": 431,
    "url": "https://github.com/dropbox/godropbox",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Go",
        "color": "#00ADD8"
      },
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "C",
        "color": "#555555"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkyMTcyNDQ0MQ==",
    "name": "goxlsx",
    "description": "Google Go (golang) library for reading XLSX files.",
    "stargazerCount": 16,
    "forkCount": 10,
    "url": "https://github.com/dropbox/goxlsx",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Go",
        "color": "#00ADD8"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkyMTc3NzE3NA==",
    "name": "huba",
    "description": "Haskell clone of Scuba",
    "stargazerCount": 2,
    "forkCount": 7,
    "url": "https://github.com/dropbox/huba",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Haskell",
        "color": "#5e5086"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkyMTgzMTI4MQ==",
    "name": "changes-client",
    "description": "A build client for Changes.",
    "stargazerCount": 18,
    "forkCount": 16,
    "url": "https://github.com/dropbox/changes-client",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "Go",
        "color": "#00ADD8"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkyMTgzMTMyMQ==",
    "name": "changes-mesos-framework",
    "description": "Mesos scheduling framework for Changes.",
    "stargazerCount": 16,
    "forkCount": 10,
    "url": "https://github.com/dropbox/changes-mesos-framework",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkyMTg4NTA1NA==",
    "name": "changes-lxc-wrapper",
    "description": "A lightweight container manager and build client wrapper for Changes.",
    "stargazerCount": 7,
    "forkCount": 7,
    "url": "https://github.com/dropbox/changes-lxc-wrapper",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkyMjA4NTY0NQ==",
    "name": "babelapi",
    "description": "Define an API once in Babel. Implement or use an existing code generator to map the API definition into usable objects and functions in any programming language.",
    "stargazerCount": 4,
    "forkCount": 7,
    "url": "https://github.com/dropbox/babelapi",
    "homepageUrl": "",
    "languages": [],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkyMjM1MjAxOQ==",
    "name": "sentry-puppet",
    "description": "Send failed puppet runs to sentry =D",
    "stargazerCount": 3,
    "forkCount": 4,
    "url": "https://github.com/dropbox/sentry-puppet",
    "homepageUrl": undefined,
    "languages": [],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkyMzc3NDk4Mg==",
    "name": "merou",
    "description": "Permission management service",
    "stargazerCount": 96,
    "forkCount": 42,
    "url": "https://github.com/dropbox/merou",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      },
      {
        "name": "CSS",
        "color": "#663399"
      },
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "Dockerfile",
        "color": "#384d54"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkyMzc3NDk5Mw==",
    "name": "groupy",
    "description": "Grouper Python Client Library",
    "stargazerCount": 10,
    "forkCount": 20,
    "url": "https://github.com/dropbox/groupy",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkyMzgwNjMyNg==",
    "name": "djinni",
    "description": "A tool for generating cross-language type declarations and interface bindings.",
    "stargazerCount": 2891,
    "forkCount": 486,
    "url": "https://github.com/dropbox/djinni",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "C++",
        "color": "#f34b7d"
      },
      {
        "name": "Java",
        "color": "#b07219"
      },
      {
        "name": "Objective-C",
        "color": "#438eff"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "Scala",
        "color": "#c22d40"
      },
      {
        "name": "Objective-C++",
        "color": "#6866fb"
      },
      {
        "name": "Lex",
        "color": "#DBCA00"
      },
      {
        "name": "CMake",
        "color": "#DA3434"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkyNDEwOTgxNw==",
    "name": "goprotoc",
    "description": undefined,
    "stargazerCount": 16,
    "forkCount": 8,
    "url": "https://github.com/dropbox/goprotoc",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "Go",
        "color": "#00ADD8"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkyNDYwOTcyOQ==",
    "name": "livegrep",
    "description": "Interactively grep source code. Source for http://livegrep.com/",
    "stargazerCount": 20,
    "forkCount": 13,
    "url": "https://github.com/dropbox/livegrep",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "Go",
        "color": "#00ADD8"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "C++",
        "color": "#f34b7d"
      },
      {
        "name": "C",
        "color": "#555555"
      },
      {
        "name": "CSS",
        "color": "#663399"
      },
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      },
      {
        "name": "Dockerfile",
        "color": "#384d54"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkyNDY1NTQ4MQ==",
    "name": "go-lxc",
    "description": "Go bindings for liblxc",
    "stargazerCount": 3,
    "forkCount": 5,
    "url": "https://github.com/dropbox/go-lxc",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Go",
        "color": "#00ADD8"
      },
      {
        "name": "C",
        "color": "#555555"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkyNTI3NTA1OQ==",
    "name": "RMConnecter",
    "description": "Connecter is an OS X app to help you interact with iTunes Connect’s Transporter binary, which allows you to interact with app metadata in iTunes Connect.",
    "stargazerCount": 2,
    "forkCount": 5,
    "url": "https://github.com/dropbox/RMConnecter",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Objective-C",
        "color": "#438eff"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkyNjI5ODM5Ng==",
    "name": "pyston-perf",
    "description": undefined,
    "stargazerCount": 8,
    "forkCount": 11,
    "url": "https://github.com/dropbox/pyston-perf",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "CSS",
        "color": "#663399"
      },
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkyODIwMTYyNw==",
    "name": "nsot",
    "description": "Network Source of Truth is an open source IPAM and network inventory database",
    "stargazerCount": 407,
    "forkCount": 64,
    "url": "https://github.com/dropbox/nsot",
    "homepageUrl": "https://nsot.readthedocs.io",
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "CSS",
        "color": "#663399"
      },
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "Dockerfile",
        "color": "#384d54"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWNweXRob24=",
        "name": "python"
      },
      {
        "id": "MDU6VG9waWNpcGFt",
        "name": "ipam"
      },
      {
        "id": "MDU6VG9waWNuZXR3b3JrLWludmVudG9yeQ==",
        "name": "network-inventory"
      },
      {
        "id": "MDU6VG9waWNzb3VyY2Utb2YtdHJ1dGg=",
        "name": "source-of-truth"
      },
      {
        "id": "MDU6VG9waWNzc290",
        "name": "ssot"
      },
      {
        "id": "MDU6VG9waWNuZXR3b3JraW5n",
        "name": "networking"
      },
      {
        "id": "MDU6VG9waWNuZXR3b3JrLWVuZ2luZWVycw==",
        "name": "network-engineers"
      },
      {
        "id": "MDU6VG9waWNuZXR3b3JrLWFkbWlu",
        "name": "network-admin"
      },
      {
        "id": "MDU6VG9waWNuZXR3b3JrLW1vbml0b3Jpbmc=",
        "name": "network-monitoring"
      },
      {
        "id": "MDU6VG9waWNkamFuZ28=",
        "name": "django"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkyOTM3NDE5Ng==",
    "name": "pynsot",
    "description": "A Python client and CLI utility for the Network Source of Truth (NSoT) REST API.",
    "stargazerCount": 46,
    "forkCount": 23,
    "url": "https://github.com/dropbox/pynsot",
    "homepageUrl": "https://pynsot.readthedocs.io",
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWNweXRob24=",
        "name": "python"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkzMDE3NDAwMw==",
    "name": "presto-hdbc",
    "description": "Presto HDBC Connector",
    "stargazerCount": 2,
    "forkCount": 4,
    "url": "https://github.com/dropbox/presto-hdbc",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Haskell",
        "color": "#5e5086"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkzMDYxODY1Mw==",
    "name": "scooter",
    "description": "An SCSS framework & UI library for Dropbox Web.",
    "stargazerCount": 790,
    "forkCount": 39,
    "url": "https://github.com/dropbox/scooter",
    "homepageUrl": "http://dropbox.github.io/scooter",
    "languages": [
      {
        "name": "CSS",
        "color": "#663399"
      },
      {
        "name": "Ruby",
        "color": "#701516"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkzMDY3MjA1MQ==",
    "name": "puppet-osx_setupassistant",
    "description": "An example of using erb templates to dynamically generate mobileconfigs.",
    "stargazerCount": 6,
    "forkCount": 5,
    "url": "https://github.com/dropbox/puppet-osx_setupassistant",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Puppet",
        "color": "#302B6D"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkzMTQ3Njc4MQ==",
    "name": "whitegold",
    "description": "Whitegold color corrector",
    "stargazerCount": 9,
    "forkCount": 7,
    "url": "https://github.com/dropbox/whitegold",
    "homepageUrl": "https://whitegold.herokuapp.com",
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "CSS",
        "color": "#663399"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkzMjQwNTk5OQ==",
    "name": "XCoverage",
    "description": "Xcode Plugin that displays coverage data in the text editor",
    "stargazerCount": 101,
    "forkCount": 14,
    "url": "https://github.com/dropbox/XCoverage",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Objective-C",
        "color": "#438eff"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkzMjYwNzQ5Mw==",
    "name": "rethink-java-driver",
    "description": "A Java RethinkDB Driver",
    "stargazerCount": 5,
    "forkCount": 9,
    "url": "https://github.com/dropbox/rethink-java-driver",
    "homepageUrl": "http://npiv.github.io/rethink-java-doc/html/",
    "languages": [
      {
        "name": "Java",
        "color": "#b07219"
      },
      {
        "name": "Protocol Buffer",
        "color": undefined
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkzMjc3NzgwMg==",
    "name": "libPhoneNumber-iOS",
    "description": "iOS library for parsing, formatting, storing and validating international phone numbers from libphonenumber library.",
    "stargazerCount": 3,
    "forkCount": 5,
    "url": "https://github.com/dropbox/libPhoneNumber-iOS",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Ruby",
        "color": "#701516"
      },
      {
        "name": "Objective-C",
        "color": "#438eff"
      },
      {
        "name": "PHP",
        "color": "#4F5D95"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkzMzI4NjA5MA==",
    "name": "dropbox-api-v2-repl",
    "description": "Utilities to test the Dropbox API v2.",
    "stargazerCount": 26,
    "forkCount": 5,
    "url": "https://github.com/dropbox/dropbox-api-v2-repl",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkzMzUyNjE2Mw==",
    "name": "pep8squad",
    "description": "PEP8 Squad, for enforcing foolish consistency",
    "stargazerCount": 10,
    "forkCount": 8,
    "url": "https://github.com/dropbox/pep8squad",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "CSS",
        "color": "#663399"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkzMzU2NzkyMw==",
    "name": "puppet_run",
    "description": "A wrapper script and launchd for running open source puppet on OS X",
    "stargazerCount": 8,
    "forkCount": 8,
    "url": "https://github.com/dropbox/puppet_run",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkzNDA4MDkxOQ==",
    "name": "libpypa",
    "description": "libpypa is a Python parser implemented in pure C++",
    "stargazerCount": 10,
    "forkCount": 6,
    "url": "https://github.com/dropbox/libpypa",
    "homepageUrl": "",
    "languages": [
      {
        "name": "CMake",
        "color": "#DA3434"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "C++",
        "color": "#f34b7d"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkzNDA5MzU1Mg==",
    "name": "virtualenv",
    "description": "Virtual Python Environment builder adopted for pyston",
    "stargazerCount": 2,
    "forkCount": 5,
    "url": "https://github.com/dropbox/virtualenv",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "PowerShell",
        "color": "#012456"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkzNTE5MjI1OQ==",
    "name": "hermes",
    "description": "SRE Event and Autotasking system",
    "stargazerCount": 49,
    "forkCount": 12,
    "url": "https://github.com/dropbox/hermes",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      },
      {
        "name": "CSS",
        "color": "#663399"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkzNTcwMTA3NA==",
    "name": "SwiftyDropbox",
    "description": "Swift SDK for the Dropbox API v2.",
    "stargazerCount": 709,
    "forkCount": 209,
    "url": "https://github.com/dropbox/SwiftyDropbox",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Swift",
        "color": "#F05138"
      },
      {
        "name": "Ruby",
        "color": "#701516"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "Objective-C",
        "color": "#438eff"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkzNTgyMzY2OQ==",
    "name": "PhotoWatch",
    "description": "A demo app for the SwiftyDropbox SDK.",
    "stargazerCount": 119,
    "forkCount": 24,
    "url": "https://github.com/dropbox/PhotoWatch",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Swift",
        "color": "#F05138"
      },
      {
        "name": "Ruby",
        "color": "#701516"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkzNjMzMTA0MQ==",
    "name": "libunwind",
    "description": "Pyston's fork of libunwind; originally from git://git.sv.gnu.org/libunwind.git",
    "stargazerCount": 23,
    "forkCount": 9,
    "url": "https://github.com/dropbox/libunwind",
    "homepageUrl": "git://git.sv.gnu.org/libunwind.git",
    "languages": [
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "C",
        "color": "#555555"
      },
      {
        "name": "C++",
        "color": "#f34b7d"
      },
      {
        "name": "Assembly",
        "color": "#6E4C13"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkzNjk1NTAxMA==",
    "name": "notouch",
    "description": "UI and event database for storing and managing server and switch installer events.",
    "stargazerCount": 5,
    "forkCount": 6,
    "url": "https://github.com/dropbox/notouch",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkzNzM0NzQyNw==",
    "name": "dropbox-sdk-python",
    "description": "The Official Dropbox API V2 SDK for Python",
    "stargazerCount": 968,
    "forkCount": 329,
    "url": "https://github.com/dropbox/dropbox-sdk-python",
    "homepageUrl": "https://www.dropbox.com/developers",
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWNweXRob24=",
        "name": "python"
      },
      {
        "id": "MDU6VG9waWNzZGs=",
        "name": "sdk"
      },
      {
        "id": "MDU6VG9waWNzZGstcHl0aG9u",
        "name": "sdk-python"
      },
      {
        "id": "MDU6VG9waWNkcm9wYm94",
        "name": "dropbox"
      },
      {
        "id": "MDU6VG9waWNkcm9wYm94LXNkaw==",
        "name": "dropbox-sdk"
      },
      {
        "id": "MDU6VG9waWNkcm9wYm94LXYy",
        "name": "dropbox-v2"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkzNzU3MjA5Mw==",
    "name": "dropbox-sdk-dotnet",
    "description": "The Official Dropbox API V2 SDK for .NET",
    "stargazerCount": 340,
    "forkCount": 442,
    "url": "https://github.com/dropbox/dropbox-sdk-dotnet",
    "homepageUrl": "https://www.dropbox.com/developers",
    "languages": [
      {
        "name": "C#",
        "color": "#178600"
      },
      {
        "name": "PowerShell",
        "color": "#012456"
      },
      {
        "name": "CSS",
        "color": "#663399"
      },
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      },
      {
        "name": "ASP.NET",
        "color": "#9400ff"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWNkb3RuZXQ=",
        "name": "dotnet"
      },
      {
        "id": "MDU6VG9waWNuZXRzdGFuZGFyZA==",
        "name": "netstandard"
      },
      {
        "id": "MDU6VG9waWNuZXRmcmFtZXdvcms=",
        "name": "netframework"
      },
      {
        "id": "MDU6VG9waWNzZGs=",
        "name": "sdk"
      },
      {
        "id": "MDU6VG9waWNzZGstZG90bmV0",
        "name": "sdk-dotnet"
      },
      {
        "id": "MDU6VG9waWNkcm9wYm94",
        "name": "dropbox"
      },
      {
        "id": "MDU6VG9waWNkcm9wYm94LXNkaw==",
        "name": "dropbox-sdk"
      },
      {
        "id": "MDU6VG9waWNkcm9wYm94LWFwaQ==",
        "name": "dropbox-api"
      },
      {
        "id": "MDU6VG9waWNkcm9wYm94LXYy",
        "name": "dropbox-v2"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkzNzc0OTY0MA==",
    "name": "dropbox-api-spec",
    "description": "The Official API Spec for Dropbox API V2 SDKs.",
    "stargazerCount": 40,
    "forkCount": 28,
    "url": "https://github.com/dropbox/dropbox-api-spec",
    "homepageUrl": "https://www.dropbox.com/developers",
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWNzcGVj",
        "name": "spec"
      },
      {
        "id": "MDU6VG9waWNzdG9uZQ==",
        "name": "stone"
      },
      {
        "id": "MDU6VG9waWNkcm9wYm94",
        "name": "dropbox"
      },
      {
        "id": "MDU6VG9waWNkcm9wYm94LWFwaQ==",
        "name": "dropbox-api"
      },
      {
        "id": "MDU6VG9waWNkcm9wYm94LXNkaw==",
        "name": "dropbox-sdk"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkzODI3MzQ1OA==",
    "name": "changes-artifacts",
    "description": "Artifact store server and client for Changes",
    "stargazerCount": 4,
    "forkCount": 7,
    "url": "https://github.com/dropbox/changes-artifacts",
    "homepageUrl": "http://changes-dropbox.readthedocs.org/en/latest/",
    "languages": [
      {
        "name": "Go",
        "color": "#00ADD8"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "Makefile",
        "color": "#427819"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkzODcwNTI1Mw==",
    "name": "nn",
    "description": "Non-undefinedable pointers for C++",
    "stargazerCount": 317,
    "forkCount": 28,
    "url": "https://github.com/dropbox/nn",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "C++",
        "color": "#f34b7d"
      },
      {
        "name": "Makefile",
        "color": "#427819"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk0MDIxNDU1NQ==",
    "name": "pyston-testsuite",
    "description": "Test suite for the Pyston project",
    "stargazerCount": 5,
    "forkCount": 8,
    "url": "https://github.com/dropbox/pyston-testsuite",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk0MDY3MTk2NQ==",
    "name": "dropbox-api-v2-explorer",
    "description": "The Official API Explorer for Dropbox's APIs",
    "stargazerCount": 45,
    "forkCount": 15,
    "url": "https://github.com/dropbox/dropbox-api-v2-explorer",
    "homepageUrl": "https://www.dropbox.com/developers",
    "languages": [
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      },
      {
        "name": "CSS",
        "color": "#663399"
      },
      {
        "name": "TypeScript",
        "color": "#3178c6"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWNkcm9wYm94",
        "name": "dropbox"
      },
      {
        "id": "MDU6VG9waWNyZWFjdA==",
        "name": "react"
      },
      {
        "id": "MDU6VG9waWNyZWFjdGpz",
        "name": "reactjs"
      },
      {
        "id": "MDU6VG9waWNleHBsb3Jlcg==",
        "name": "explorer"
      },
      {
        "id": "MDU6VG9waWNhcGk=",
        "name": "api"
      },
      {
        "id": "MDU6VG9waWNkcm9wYm94LWFwaQ==",
        "name": "dropbox-api"
      },
      {
        "id": "MDU6VG9waWNkcm9wYm94LXNkaw==",
        "name": "dropbox-sdk"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk0MDY5MTg4Ng==",
    "name": "hackpad",
    "description": "Hackpad is a web-based realtime wiki.",
    "stargazerCount": 3621,
    "forkCount": 523,
    "url": "https://github.com/dropbox/hackpad",
    "homepageUrl": "https://hackpad.com",
    "languages": [
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "Objective-C",
        "color": "#438eff"
      },
      {
        "name": "C",
        "color": "#555555"
      },
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      },
      {
        "name": "C++",
        "color": "#f34b7d"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "Nginx",
        "color": "#009639"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      },
      {
        "name": "CSS",
        "color": "#663399"
      },
      {
        "name": "Scala",
        "color": "#c22d40"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk0MTA2MDExOQ==",
    "name": "Dropline",
    "description": "Tool to monitor how busy an area is using Wi-Fi. Originally intended for Dropbox's Tuck Shop.",
    "stargazerCount": 18,
    "forkCount": 9,
    "url": "https://github.com/dropbox/Dropline",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Haskell",
        "color": "#5e5086"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk0MTU3Nzg0Mg==",
    "name": "mantle",
    "description": "Datacenter Management System",
    "stargazerCount": 2,
    "forkCount": 7,
    "url": "https://github.com/dropbox/mantle",
    "homepageUrl": undefined,
    "languages": [],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk0MjYxMzMxNA==",
    "name": "lmdb-rs",
    "description": "Rust bindings for LMDB",
    "stargazerCount": 2,
    "forkCount": 4,
    "url": "https://github.com/dropbox/lmdb-rs",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Rust",
        "color": "#dea584"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk0MjczOTQyNg==",
    "name": "revision-browser",
    "description": "Dropbox app that uses Dropins, API v1, and v2!",
    "stargazerCount": 6,
    "forkCount": 9,
    "url": "https://github.com/dropbox/revision-browser",
    "homepageUrl": "https://revision-browser.herokuapp.com",
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      },
      {
        "name": "CSS",
        "color": "#663399"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk0MjkwMjkwMw==",
    "name": "rust-openssl",
    "description": "OpenSSL bindings for Rust",
    "stargazerCount": 1,
    "forkCount": 3,
    "url": "https://github.com/dropbox/rust-openssl",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Rust",
        "color": "#dea584"
      },
      {
        "name": "C",
        "color": "#555555"
      },
      {
        "name": "RenderScript",
        "color": undefined
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk0MzE3MTg5MQ==",
    "name": "hocrux",
    "description": "Handwritten optical character recognition",
    "stargazerCount": 25,
    "forkCount": 7,
    "url": "https://github.com/dropbox/hocrux",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk0MzMzMTAwOQ==",
    "name": "pytest-flakefinder",
    "description": "Runs tests multiple times to expose flakiness.",
    "stargazerCount": 152,
    "forkCount": 14,
    "url": "https://github.com/dropbox/pytest-flakefinder",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk0MzQ2NTQxOA==",
    "name": "xz",
    "description": ":floppy_disk: Free general-purpose data compression software with high compression ratio.",
    "stargazerCount": 5,
    "forkCount": 4,
    "url": "https://github.com/dropbox/xz",
    "homepageUrl": "http://tukaani.org/xz/",
    "languages": [
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "C",
        "color": "#555555"
      },
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "C++",
        "color": "#f34b7d"
      },
      {
        "name": "Objective-C",
        "color": "#438eff"
      },
      {
        "name": "Assembly",
        "color": "#6E4C13"
      },
      {
        "name": "Groff",
        "color": undefined
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk0NDk5Njc5MQ==",
    "name": "css-style-guide",
    "description": "Dropbox’s (S)CSS authoring style guide",
    "stargazerCount": 1217,
    "forkCount": 85,
    "url": "https://github.com/dropbox/css-style-guide",
    "homepageUrl": undefined,
    "languages": [],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk0NTIzMDQyNg==",
    "name": "spookify",
    "description": "haunted dropbox! ghosts on images.",
    "stargazerCount": 5,
    "forkCount": 4,
    "url": "https://github.com/dropbox/spookify",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "CSS",
        "color": "#663399"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk0NTcwOTQ1MA==",
    "name": "DropboxBusinessScripts",
    "description": "Scripting resources to serve as a base for common Dropbox Business tasks",
    "stargazerCount": 41,
    "forkCount": 21,
    "url": "https://github.com/dropbox/DropboxBusinessScripts",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "PowerShell",
        "color": "#012456"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "Java",
        "color": "#b07219"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk0NTg5NjM2Nw==",
    "name": "bazel",
    "description": "Correct, reproducible, and fast builds for everyone.",
    "stargazerCount": 5,
    "forkCount": 6,
    "url": "https://github.com/dropbox/bazel",
    "homepageUrl": "http://bazel.io",
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "Java",
        "color": "#b07219"
      },
      {
        "name": "C++",
        "color": "#f34b7d"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      },
      {
        "name": "C",
        "color": "#555555"
      },
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "PowerShell",
        "color": "#012456"
      },
      {
        "name": "Objective-C",
        "color": "#438eff"
      },
      {
        "name": "Smarty",
        "color": "#f0c040"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk0NjgyNTk4Nw==",
    "name": "marshal",
    "description": "A Kafka consumer coordination library for Go.",
    "stargazerCount": 38,
    "forkCount": 14,
    "url": "https://github.com/dropbox/marshal",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Go",
        "color": "#00ADD8"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk0NzE0MDI0Ng==",
    "name": "protobuf",
    "description": "Protocol Buffers - Google's data interchange format",
    "stargazerCount": 3,
    "forkCount": 1,
    "url": "https://github.com/dropbox/protobuf",
    "homepageUrl": "https://developers.google.com/protocol-buffers/",
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "Ruby",
        "color": "#701516"
      },
      {
        "name": "Batchfile",
        "color": "#C1F12E"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "Java",
        "color": "#b07219"
      },
      {
        "name": "Protocol Buffer",
        "color": undefined
      },
      {
        "name": "CMake",
        "color": "#DA3434"
      },
      {
        "name": "C++",
        "color": "#f34b7d"
      },
      {
        "name": "Objective-C",
        "color": "#438eff"
      },
      {
        "name": "C#",
        "color": "#178600"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk0NzE3MDc1Nw==",
    "name": "gogoprotobuf",
    "description": "Protocol Buffers for Go with Gadgets",
    "stargazerCount": 3,
    "forkCount": 4,
    "url": "https://github.com/dropbox/gogoprotobuf",
    "homepageUrl": "gogo.github.io",
    "languages": [
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "Go",
        "color": "#00ADD8"
      },
      {
        "name": "Protocol Buffer",
        "color": undefined
      },
      {
        "name": "Shell",
        "color": "#89e051"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk0NzU5MDU5Mw==",
    "name": "presto",
    "description": "Distributed SQL query engine for running interactive analytic queries against big data sources.",
    "stargazerCount": 1,
    "forkCount": 7,
    "url": "https://github.com/dropbox/presto",
    "homepageUrl": "https://prestodb.io",
    "languages": [
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "Java",
        "color": "#b07219"
      },
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      },
      {
        "name": "PLSQL",
        "color": "#dad8d8"
      },
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      },
      {
        "name": "ANTLR",
        "color": "#9DC3FF"
      },
      {
        "name": "Thrift",
        "color": "#D12127"
      },
      {
        "name": "CSS",
        "color": "#663399"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk0ODE1MTMwOA==",
    "name": "strongpoc",
    "description": "Strong Point of Contact",
    "stargazerCount": 0,
    "forkCount": 7,
    "url": "https://github.com/dropbox/strongpoc",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk1MDMxODMxMw==",
    "name": "dropbox-sdk-go-unofficial",
    "description": ":warning: An UNOFFICIAL Dropbox v2 API SDK for Go",
    "stargazerCount": 186,
    "forkCount": 39,
    "url": "https://github.com/dropbox/dropbox-sdk-go-unofficial",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Go",
        "color": "#00ADD8"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWNkcm9wYm94LWFwaQ==",
        "name": "dropbox-api"
      },
      {
        "id": "MDU6VG9waWNkcm9wYm94LXNkaw==",
        "name": "dropbox-sdk"
      },
      {
        "id": "MDU6VG9waWNzZGs=",
        "name": "sdk"
      },
      {
        "id": "MDU6VG9waWNnb2xhbmctc2Rr",
        "name": "golang-sdk"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk1MDM2NjQ5OA==",
    "name": "datagraph",
    "description": undefined,
    "stargazerCount": 126,
    "forkCount": 6,
    "url": "https://github.com/dropbox/datagraph",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Haskell",
        "color": "#5e5086"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "Lua",
        "color": "#000080"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk1MDM3MDM3MA==",
    "name": "dbxcli",
    "description": "A command line client for Dropbox built using the Go SDK",
    "stargazerCount": 1091,
    "forkCount": 103,
    "url": "https://github.com/dropbox/dbxcli",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Go",
        "color": "#00ADD8"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWNkcm9wYm94",
        "name": "dropbox"
      },
      {
        "id": "MDU6VG9waWNnb2xhbmctYXBwbGljYXRpb24=",
        "name": "golang-application"
      },
      {
        "id": "MDU6VG9waWNjbGk=",
        "name": "cli"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk1MDM3NzI4NA==",
    "name": "stopwatch",
    "description": "Scoped, nested, aggregated python timing library",
    "stargazerCount": 67,
    "forkCount": 15,
    "url": "https://github.com/dropbox/stopwatch",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk1MDU0NzMyMA==",
    "name": "DropboxBusinessAdminTool",
    "description": "Power User tool to assist Dropbox Business Administrators in managing their Dropbox team",
    "stargazerCount": 45,
    "forkCount": 13,
    "url": "https://github.com/dropbox/DropboxBusinessAdminTool",
    "homepageUrl": "",
    "languages": [
      {
        "name": "C#",
        "color": "#178600"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk1MDc1MjIxOA==",
    "name": "dbx-unittest2pytest",
    "description": "Convert unittest asserts to pytest rewritten asserts.",
    "stargazerCount": 28,
    "forkCount": 8,
    "url": "https://github.com/dropbox/dbx-unittest2pytest",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk1MDk1OTI0OQ==",
    "name": "kafka",
    "description": "Go driver for Kafka",
    "stargazerCount": 43,
    "forkCount": 9,
    "url": "https://github.com/dropbox/kafka",
    "homepageUrl": "https://godoc.org/github.com/optiopay/kafka",
    "languages": [
      {
        "name": "Go",
        "color": "#00ADD8"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk1MTExNDk0Nw==",
    "name": "gitolite",
    "description": "Hosting git repositories -- Gitolite allows you to setup git hosting on a central server, with very fine-grained access control and many (many!) more powerful features.",
    "stargazerCount": 2,
    "forkCount": 2,
    "url": "https://github.com/dropbox/gitolite",
    "homepageUrl": "http://wiki.github.com/sitaramc/gitolite/",
    "languages": [
      {
        "name": "Perl",
        "color": "#0298c3"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "Roff",
        "color": "#ecdebe"
      },
      {
        "name": "Vim Script",
        "color": "#199f4b"
      },
      {
        "name": "Perl 6",
        "color": undefined
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk1MTQ3MDA5Mg==",
    "name": "lopper",
    "description": "A lightweight C++ framework for vectorizing image-processing code",
    "stargazerCount": 76,
    "forkCount": 62,
    "url": "https://github.com/dropbox/lopper",
    "homepageUrl": "https://dropbox.github.io/lopper/",
    "languages": [
      {
        "name": "CMake",
        "color": "#DA3434"
      },
      {
        "name": "C++",
        "color": "#f34b7d"
      },
      {
        "name": "Makefile",
        "color": "#427819"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk1MjEwODg3NA==",
    "name": "node",
    "description": "Node.js JavaScript runtime :sparkles::turtle::rocket::sparkles:",
    "stargazerCount": 2,
    "forkCount": 2,
    "url": "https://github.com/dropbox/node",
    "homepageUrl": "https://nodejs.org",
    "languages": [
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      },
      {
        "name": "Ruby",
        "color": "#701516"
      },
      {
        "name": "C",
        "color": "#555555"
      },
      {
        "name": "C++",
        "color": "#f34b7d"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "R",
        "color": "#198CE7"
      },
      {
        "name": "PHP",
        "color": "#4F5D95"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk1MzE2NzM5NA==",
    "name": "brotli-rs",
    "description": "A Brotli implementation in pure and safe Rust",
    "stargazerCount": 6,
    "forkCount": 4,
    "url": "https://github.com/dropbox/brotli-rs",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Rust",
        "color": "#dea584"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWNjb21wcmVzc2lvbg==",
        "name": "compression"
      },
      {
        "id": "MDU6VG9waWNkZWNvbXByZXNzaW9u",
        "name": "decompression"
      },
      {
        "id": "MDU6VG9waWNicm90bGktZGVjb2Rlcg==",
        "name": "brotli-decoder"
      },
      {
        "id": "MDU6VG9waWNicm90bGk=",
        "name": "brotli"
      },
      {
        "id": "MDU6VG9waWNydXN0LWxpYnJhcnk=",
        "name": "rust-library"
      },
      {
        "id": "MDU6VG9waWNydXN0",
        "name": "rust"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk1MzE3NjQ3OA==",
    "name": "python-brotli-rs",
    "description": "Bindings for the brotli rust implementation into python",
    "stargazerCount": 2,
    "forkCount": 4,
    "url": "https://github.com/dropbox/python-brotli-rs",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "Rust",
        "color": "#dea584"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk1MzcwNTI1NQ==",
    "name": "avrecode",
    "description": "Lossless video compression: decode an H.264-encoded video file and reversibly re-encode it as as a smaller file.",
    "stargazerCount": 281,
    "forkCount": 36,
    "url": "https://github.com/dropbox/avrecode",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "C++",
        "color": "#f34b7d"
      },
      {
        "name": "Protocol Buffer",
        "color": undefined
      },
      {
        "name": "C",
        "color": "#555555"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk1MzcxNDcwOQ==",
    "name": "libavcodec-hooks",
    "description": "Fork of ffmpeg (git://source.ffmpeg.org/ffmpeg.git). Required to compile avrecode lossless video compression (https://github.com/dropbox/avrecode). Adds hooks into low-level coding functions of libavcodec. License: LGPL.",
    "stargazerCount": 19,
    "forkCount": 16,
    "url": "https://github.com/dropbox/libavcodec-hooks",
    "homepageUrl": "https://github.com/dropbox/avrecode",
    "languages": [
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "C",
        "color": "#555555"
      },
      {
        "name": "C++",
        "color": "#f34b7d"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "Perl",
        "color": "#0298c3"
      },
      {
        "name": "Assembly",
        "color": "#6E4C13"
      },
      {
        "name": "Objective-C",
        "color": "#438eff"
      },
      {
        "name": "Verilog",
        "color": "#b2b7f8"
      },
      {
        "name": "Groff",
        "color": undefined
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk1NTI4NDA5OA==",
    "name": "rust-alloc-no-stdlib",
    "description": "An interface to a generic allocator so a no_std rust library can allocate memory, with, or without stdlib being linked.",
    "stargazerCount": 176,
    "forkCount": 18,
    "url": "https://github.com/dropbox/rust-alloc-no-stdlib",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Rust",
        "color": "#dea584"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk1NTU2NTU4NQ==",
    "name": "dropbox-sdk-js",
    "description": "The Official Dropbox API V2 SDK for Javascript",
    "stargazerCount": 962,
    "forkCount": 356,
    "url": "https://github.com/dropbox/dropbox-sdk-js",
    "homepageUrl": "https://www.dropbox.com/developers",
    "languages": [
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "TypeScript",
        "color": "#3178c6"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWNqYXZhc2NyaXB0",
        "name": "javascript"
      },
      {
        "id": "MDU6VG9waWN0eXBlc2NyaXB0",
        "name": "typescript"
      },
      {
        "id": "MDU6VG9waWNub2RlanM=",
        "name": "nodejs"
      },
      {
        "id": "MDU6VG9waWNub2Rl",
        "name": "node"
      },
      {
        "id": "MDU6VG9waWNub2RlLWpz",
        "name": "node-js"
      },
      {
        "id": "MDU6VG9waWNzZGs=",
        "name": "sdk"
      },
      {
        "id": "MDU6VG9waWNzZGstamF2YXNjcmlwdA==",
        "name": "sdk-javascript"
      },
      {
        "id": "MDU6VG9waWNzZGstdHlwZXNjcmlwdA==",
        "name": "sdk-typescript"
      },
      {
        "id": "MDU6VG9waWNzZGstbm9kZWpz",
        "name": "sdk-nodejs"
      },
      {
        "id": "MDU6VG9waWNzZGstbm9kZQ==",
        "name": "sdk-node"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk1NjQyMTU1Ng==",
    "name": "rust-brotli",
    "description": "Brotli compressor and decompressor written in rust that optionally avoids the stdlib",
    "stargazerCount": 891,
    "forkCount": 89,
    "url": "https://github.com/dropbox/rust-brotli",
    "homepageUrl": "https://dropbox.tech/infrastructure/-broccoli--syncing-faster-by-syncing-less",
    "languages": [
      {
        "name": "Rust",
        "color": "#dea584"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "C",
        "color": "#555555"
      },
      {
        "name": "PowerShell",
        "color": "#012456"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "Go",
        "color": "#00ADD8"
      },
      {
        "name": "Just",
        "color": "#384d54"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWNkZWNvbXByZXNzaW9u",
        "name": "decompression"
      },
      {
        "id": "MDU6VG9waWNicm90bGk=",
        "name": "brotli"
      },
      {
        "id": "MDU6VG9waWNydXN0",
        "name": "rust"
      },
      {
        "id": "MDU6VG9waWNicm90bGktZGVjb21wcmVzc29y",
        "name": "brotli-decompressor"
      },
      {
        "id": "MDU6VG9waWNydXN0bGFuZw==",
        "name": "rustlang"
      },
      {
        "id": "MDU6VG9waWNzYWZl",
        "name": "safe"
      },
      {
        "id": "MDU6VG9waWNicm90bGktY29tcHJlc3Npb24=",
        "name": "brotli-compression"
      },
      {
        "id": "MDU6VG9waWNicm90bGktZW5jb2Rlcg==",
        "name": "brotli-encoder"
      },
      {
        "id": "MDU6VG9waWNicm90bGktY29tcHJlc3Nvcg==",
        "name": "brotli-compressor"
      },
      {
        "id": "MDU6VG9waWNjb21wcmVzc2lvbg==",
        "name": "compression"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk1NjkwNTY3OQ==",
    "name": "AskBox",
    "description": "A javascript widget to let users ask you questions right from your documentation webpage.",
    "stargazerCount": 5,
    "forkCount": 5,
    "url": "https://github.com/dropbox/AskBox",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      },
      {
        "name": "CSS",
        "color": "#663399"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk1NzQ2MDY3NA==",
    "name": "rust-brotli-decompressor",
    "description": "An implementation of https://github.com/google/brotli in rust avoiding the stdlib",
    "stargazerCount": 58,
    "forkCount": 26,
    "url": "https://github.com/dropbox/rust-brotli-decompressor",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Rust",
        "color": "#dea584"
      },
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "C",
        "color": "#555555"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk1OTMxNTEyOA==",
    "name": "stone",
    "description": "The Official API Spec Language for Dropbox API V2",
    "stargazerCount": 409,
    "forkCount": 80,
    "url": "https://github.com/dropbox/stone",
    "homepageUrl": "https://www.dropbox.com/developers",
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "Swift",
        "color": "#F05138"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "Objective-C",
        "color": "#438eff"
      },
      {
        "name": "Jinja",
        "color": "#a52a22"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWNweXRob24=",
        "name": "python"
      },
      {
        "id": "MDU6VG9waWNzdG9uZQ==",
        "name": "stone"
      },
      {
        "id": "MDU6VG9waWNhcGk=",
        "name": "api"
      },
      {
        "id": "MDU6VG9waWNkcm9wYm94",
        "name": "dropbox"
      },
      {
        "id": "MDU6VG9waWNkcm9wYm94LWFwaQ==",
        "name": "dropbox-api"
      },
      {
        "id": "MDU6VG9waWNkcm9wYm94LXYy",
        "name": "dropbox-v2"
      },
      {
        "id": "MDU6VG9waWNnZW5lcmF0b3I=",
        "name": "generator"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk2MDA2NTMzNA==",
    "name": "rust-subprocess-communicate",
    "description": "This implements the python subprocess.communicate tool for rust",
    "stargazerCount": 13,
    "forkCount": 6,
    "url": "https://github.com/dropbox/rust-subprocess-communicate",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Rust",
        "color": "#dea584"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk2MDgxMDE0NA==",
    "name": "dropbox-sdk-obj-c",
    "description": "Official Objective-C SDK for the Dropbox API v2.",
    "stargazerCount": 182,
    "forkCount": 119,
    "url": "https://github.com/dropbox/dropbox-sdk-obj-c",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Ruby",
        "color": "#701516"
      },
      {
        "name": "Objective-C",
        "color": "#438eff"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "CSS",
        "color": "#663399"
      },
      {
        "name": "C",
        "color": "#555555"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWNkcm9wYm94LWFwaQ==",
        "name": "dropbox-api"
      },
      {
        "id": "MDU6VG9waWNvYmplY3RpdmUtYw==",
        "name": "objective-c"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk2MTMzNDQwMA==",
    "name": "react",
    "description": "A declarative, efficient, and flexible JavaScript library for building user interfaces.",
    "stargazerCount": 2,
    "forkCount": 4,
    "url": "https://github.com/dropbox/react",
    "homepageUrl": "https://facebook.github.io/react/",
    "languages": [
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "C++",
        "color": "#f34b7d"
      },
      {
        "name": "C",
        "color": "#555555"
      },
      {
        "name": "CoffeeScript",
        "color": "#244776"
      },
      {
        "name": "TypeScript",
        "color": "#3178c6"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      },
      {
        "name": "CSS",
        "color": "#663399"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk2MTY3NzU0Ng==",
    "name": "python-invariant",
    "description": "A simple library for ensuring arguments to functions are constant.",
    "stargazerCount": 8,
    "forkCount": 3,
    "url": "https://github.com/dropbox/python-invariant",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk2MjgyMDkwMw==",
    "name": "zookeeper",
    "description": undefined,
    "stargazerCount": 2,
    "forkCount": 4,
    "url": "https://github.com/dropbox/zookeeper",
    "homepageUrl": undefined,
    "languages": [],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk2MzI2MjE3OA==",
    "name": "lepton",
    "description": "Lepton is a tool and file format for losslessly compressing JPEGs by an average of 22%.",
    "stargazerCount": 5009,
    "forkCount": 350,
    "url": "https://github.com/dropbox/lepton",
    "homepageUrl": "https://blogs.dropbox.com/tech/2016/07/lepton-image-compression-saving-22-losslessly-from-images-at-15mbs/",
    "languages": [
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "C++",
        "color": "#f34b7d"
      },
      {
        "name": "CMake",
        "color": "#DA3434"
      },
      {
        "name": "Perl",
        "color": "#0298c3"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "M4",
        "color": undefined
      },
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      },
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      },
      {
        "name": "Hack",
        "color": "#878787"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWNqcGVn",
        "name": "jpeg"
      },
      {
        "id": "MDU6VG9waWNsb3NzbGVzcy1jb21wcmVzc2lvbi1hbGdvcml0aG0=",
        "name": "lossless-compression-algorithm"
      },
      {
        "id": "MDU6VG9waWNkZWNvbXByZXNzaW9u",
        "name": "decompression"
      },
      {
        "id": "MDU6VG9waWNjb21wcmVzc2lvbi1hbGdvcml0aG0=",
        "name": "compression-algorithm"
      },
      {
        "id": "MDU6VG9waWNjb21wcmVzc2lvbg==",
        "name": "compression"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk2MzQ0NzUyNQ==",
    "name": "llama-archive",
    "description": "Loss & LAtency MAtrix",
    "stargazerCount": 44,
    "forkCount": 10,
    "url": "https://github.com/dropbox/llama-archive",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWNsYXRlbmN5",
        "name": "latency"
      },
      {
        "id": "MDU6VG9waWNsb3Nz",
        "name": "loss"
      },
      {
        "id": "MDU6VG9waWNtYXRyaXg=",
        "name": "matrix"
      },
      {
        "id": "MDU6VG9waWNuZXR3b3Jr",
        "name": "network"
      },
      {
        "id": "MDU6VG9waWNtb25pdG9yaW5n",
        "name": "monitoring"
      },
      {
        "id": "MDU6VG9waWN1ZHA=",
        "name": "udp"
      },
      {
        "id": "MDU6VG9waWN0ZWxlbWV0cnk=",
        "name": "telemetry"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk2MzgxNDk5Mg==",
    "name": "terraform",
    "description": "Terraform is a tool for building, changing, and combining infrastructure safely and efficiently.",
    "stargazerCount": 3,
    "forkCount": 2,
    "url": "https://github.com/dropbox/terraform",
    "homepageUrl": "https://www.terraform.io/",
    "languages": [
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "Go",
        "color": "#00ADD8"
      },
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "HCL",
        "color": "#844FBA"
      },
      {
        "name": "Ruby",
        "color": "#701516"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      },
      {
        "name": "CSS",
        "color": "#663399"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk2MzgxODUwNg==",
    "name": "plyj",
    "description": "A Java parser written in Python using PLY.",
    "stargazerCount": 4,
    "forkCount": 4,
    "url": "https://github.com/dropbox/plyj",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk2NDY4NTIzNQ==",
    "name": "react-framestats",
    "description": "Performance monitoring tool for React applications",
    "stargazerCount": 6,
    "forkCount": 6,
    "url": "https://github.com/dropbox/react-framestats",
    "homepageUrl": "",
    "languages": [
      {
        "name": "TypeScript",
        "color": "#3178c6"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk2NTA0MDE2MA==",
    "name": "libseccomp",
    "description": "The main libseccomp repository",
    "stargazerCount": 1,
    "forkCount": 5,
    "url": "https://github.com/dropbox/libseccomp",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "M4",
        "color": undefined
      },
      {
        "name": "C",
        "color": "#555555"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk2NTIzNDM5Nw==",
    "name": "video.js",
    "description": "Video.js - open source HTML5 & Flash video player",
    "stargazerCount": 4,
    "forkCount": 1,
    "url": "https://github.com/dropbox/video.js",
    "homepageUrl": "www.videojs.com",
    "languages": [
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "CSS",
        "color": "#663399"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk2NTIzNDUzOA==",
    "name": "videojs-contrib-hls",
    "description": "HLS library for video.js",
    "stargazerCount": 2,
    "forkCount": 5,
    "url": "https://github.com/dropbox/videojs-contrib-hls",
    "homepageUrl": "http://videojs.github.io/videojs-contrib-hls/",
    "languages": [
      {
        "name": "HTML",
        "color": "#e34c26"
      },
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      },
      {
        "name": "CSS",
        "color": "#663399"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk2NjM5NDA1Nw==",
    "name": "securitybot",
    "description": "Distributed alerting for the masses!",
    "stargazerCount": 992,
    "forkCount": 110,
    "url": "https://github.com/dropbox/securitybot",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "CSS",
        "color": "#663399"
      },
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWNib3Q=",
        "name": "bot"
      },
      {
        "id": "MDU6VG9waWNkdW8=",
        "name": "duo"
      },
      {
        "id": "MDU6VG9waWNzbGFjaw==",
        "name": "slack"
      },
      {
        "id": "MDU6VG9waWNzZWN1cml0eS1hdXRvbWF0aW9u",
        "name": "security-automation"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk3NjQ4NjE1Mg==",
    "name": "goprotobuf",
    "description": "Go support for Google's protocol buffers",
    "stargazerCount": 3,
    "forkCount": 3,
    "url": "https://github.com/dropbox/goprotobuf",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "Go",
        "color": "#00ADD8"
      },
      {
        "name": "Protocol Buffer",
        "color": undefined
      },
      {
        "name": "Shell",
        "color": "#89e051"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk3NzA5NDI4Ng==",
    "name": "es6-promise",
    "description": "A polyfill for ES6-style Promises",
    "stargazerCount": 2,
    "forkCount": 3,
    "url": "https://github.com/dropbox/es6-promise",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk3Nzk2NjUwOQ==",
    "name": "golang-net",
    "description": "[mirror] Go supplementary network libraries",
    "stargazerCount": 2,
    "forkCount": 2,
    "url": "https://github.com/dropbox/golang-net",
    "homepageUrl": "https://godoc.org/golang.org/x/net",
    "languages": [
      {
        "name": "Go",
        "color": "#00ADD8"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      },
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "Assembly",
        "color": "#6E4C13"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk3ODc1ODEyMA==",
    "name": "percona-server",
    "description": "Percona Server",
    "stargazerCount": 1,
    "forkCount": 4,
    "url": "https://github.com/dropbox/percona-server",
    "homepageUrl": "https://www.percona.com/software/mysql-database/percona-server",
    "languages": [
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "CMake",
        "color": "#DA3434"
      },
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "C++",
        "color": "#f34b7d"
      },
      {
        "name": "C",
        "color": "#555555"
      },
      {
        "name": "Perl",
        "color": "#0298c3"
      },
      {
        "name": "M4",
        "color": undefined
      },
      {
        "name": "Emacs Lisp",
        "color": "#c065db"
      },
      {
        "name": "Java",
        "color": "#b07219"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk4MDI1MzUyNA==",
    "name": "pilot",
    "description": "Cross-platform MVVM in Swift",
    "stargazerCount": 113,
    "forkCount": 23,
    "url": "https://github.com/dropbox/pilot",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Swift",
        "color": "#F05138"
      },
      {
        "name": "Objective-C",
        "color": "#438eff"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWNzd2lmdA==",
        "name": "swift"
      },
      {
        "id": "MDU6VG9waWNpb3M=",
        "name": "ios"
      },
      {
        "id": "MDU6VG9waWNtYWNvcw==",
        "name": "macos"
      },
      {
        "id": "MDU6VG9waWN1aWtpdA==",
        "name": "uikit"
      },
      {
        "id": "MDU6VG9waWNhcHBraXQ=",
        "name": "appkit"
      },
      {
        "id": "MDU6VG9waWNtdnZt",
        "name": "mvvm"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk4MDQ3NDc4OA==",
    "name": "onenote-parser",
    "description": undefined,
    "stargazerCount": 35,
    "forkCount": 9,
    "url": "https://github.com/dropbox/onenote-parser",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "C++",
        "color": "#f34b7d"
      },
      {
        "name": "Go",
        "color": "#00ADD8"
      },
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "C",
        "color": "#555555"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk4MTM5NzM4NQ==",
    "name": "dropbox-api-content-hasher",
    "description": "Code to compute the Dropbox API's \"content_hash\"",
    "stargazerCount": 72,
    "forkCount": 31,
    "url": "https://github.com/dropbox/dropbox-api-content-hasher",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "Java",
        "color": "#b07219"
      },
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "Rust",
        "color": "#dea584"
      },
      {
        "name": "C#",
        "color": "#178600"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk4MTg2MDA2OQ==",
    "name": "percona-xtrabackup",
    "description": "Open source hot backup tool for InnoDB and XtraDB databases",
    "stargazerCount": 1,
    "forkCount": 5,
    "url": "https://github.com/dropbox/percona-xtrabackup",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "CMake",
        "color": "#DA3434"
      },
      {
        "name": "C",
        "color": "#555555"
      },
      {
        "name": "C++",
        "color": "#f34b7d"
      },
      {
        "name": "Perl",
        "color": "#0298c3"
      },
      {
        "name": "Roff",
        "color": "#ecdebe"
      },
      {
        "name": "Batchfile",
        "color": "#C1F12E"
      },
      {
        "name": "Pascal",
        "color": "#E3F171"
      },
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk4MTg3NjY3OA==",
    "name": "ruba",
    "description": "fast in-memory analytics datastore in Rust",
    "stargazerCount": 20,
    "forkCount": 6,
    "url": "https://github.com/dropbox/ruba",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Rust",
        "color": "#dea584"
      },
      {
        "name": "TypeScript",
        "color": "#3178c6"
      },
      {
        "name": "CSS",
        "color": "#663399"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      },
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk4MjI2MTMxNQ==",
    "name": "pybridge",
    "description": "Reuse Python code in native Android applications",
    "stargazerCount": 3,
    "forkCount": 3,
    "url": "https://github.com/dropbox/pybridge",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "Java",
        "color": "#b07219"
      },
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "C",
        "color": "#555555"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk4MzA4OTg5NA==",
    "name": "grallama-panel",
    "description": "GraLLAMA panel for LLAMA data",
    "stargazerCount": 16,
    "forkCount": 11,
    "url": "https://github.com/dropbox/grallama-panel",
    "homepageUrl": "",
    "languages": [
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      },
      {
        "name": "CSS",
        "color": "#663399"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWNsYXRlbmN5",
        "name": "latency"
      },
      {
        "id": "MDU6VG9waWNsb3Nz",
        "name": "loss"
      },
      {
        "id": "MDU6VG9waWNtYXRyaXg=",
        "name": "matrix"
      },
      {
        "id": "MDU6VG9waWNsbGFtYQ==",
        "name": "llama"
      },
      {
        "id": "MDU6VG9waWNuZXR3b3Jr",
        "name": "network"
      },
      {
        "id": "MDU6VG9waWNtb25pdG9yaW5n",
        "name": "monitoring"
      },
      {
        "id": "MDU6VG9waWN0ZWxlbWV0cnk=",
        "name": "telemetry"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk4NTg4NTUzNg==",
    "name": "node-statsd",
    "description": "node.js client for Etsy'd StatsD server",
    "stargazerCount": 1,
    "forkCount": 1,
    "url": "https://github.com/dropbox/node-statsd",
    "homepageUrl": "",
    "languages": [
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk4NjM3MjcyOA==",
    "name": "query-playback",
    "description": "Query Playback",
    "stargazerCount": 2,
    "forkCount": 3,
    "url": "https://github.com/dropbox/query-playback",
    "homepageUrl": "",
    "languages": [
      {
        "name": "CMake",
        "color": "#DA3434"
      },
      {
        "name": "C++",
        "color": "#f34b7d"
      },
      {
        "name": "C",
        "color": "#555555"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk4ODkyMDM4MA==",
    "name": "git-rbr",
    "description": "Git \"recursive rebase\".",
    "stargazerCount": 16,
    "forkCount": 7,
    "url": "https://github.com/dropbox/git-rbr",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk4OTUxNDUzOA==",
    "name": "idle.ts",
    "description": "A TypeScript library used to detect idle/active users.",
    "stargazerCount": 82,
    "forkCount": 9,
    "url": "https://github.com/dropbox/idle.ts",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "TypeScript",
        "color": "#3178c6"
      },
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk5NjE1NTY4NA==",
    "name": "divans",
    "description": "Building better compression together",
    "stargazerCount": 371,
    "forkCount": 16,
    "url": "https://github.com/dropbox/divans",
    "homepageUrl": "https://blogs.dropbox.com/tech/2018/06/building-better-compression-together-with-divans/",
    "languages": [
      {
        "name": "Rust",
        "color": "#dea584"
      },
      {
        "name": "C",
        "color": "#555555"
      },
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      },
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWNjb21wcmVzc2lvbi1hbGdvcml0aG0=",
        "name": "compression-algorithm"
      },
      {
        "id": "MDU6VG9waWNjb21wcmVzc2lvbg==",
        "name": "compression"
      },
      {
        "id": "MDU6VG9waWNkZWNvbXByZXNz",
        "name": "decompress"
      },
      {
        "id": "MDU6VG9waWNkZWNvbXByZXNzb3I=",
        "name": "decompressor"
      },
      {
        "id": "MDU6VG9waWNydXN0LWxhbmc=",
        "name": "rust-lang"
      },
      {
        "id": "MDU6VG9waWNydXN0",
        "name": "rust"
      },
      {
        "id": "MDU6VG9waWNhcml0aG1ldGljLWNvZGluZw==",
        "name": "arithmetic-coding"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnk5ODY3NjYxMQ==",
    "name": "rules_node",
    "description": "Node rules for Bazel (unsupported)",
    "stargazerCount": 53,
    "forkCount": 16,
    "url": "https://github.com/dropbox/rules_node",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWNiYXplbA==",
        "name": "bazel"
      },
      {
        "id": "MDU6VG9waWNub2Rl",
        "name": "node"
      },
      {
        "id": "MDU6VG9waWN3ZWJwYWNr",
        "name": "webpack"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxMTA1OTcyODA=",
    "name": "pyannotate",
    "description": "Auto-generate PEP-484 annotations",
    "stargazerCount": 1447,
    "forkCount": 61,
    "url": "https://github.com/dropbox/pyannotate",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxMTI3OTUyNTQ=",
    "name": "nodegallerytutorial",
    "description": "Step by step tutorial to build a production-ready photo gallery Web Service using Node.JS and Dropbox.",
    "stargazerCount": 61,
    "forkCount": 25,
    "url": "https://github.com/dropbox/nodegallerytutorial",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      },
      {
        "name": "CSS",
        "color": "#663399"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxMTY0MTMyNTg=",
    "name": "efivalidate",
    "description": "Tool to validate EFI saved images against Apple baselines.",
    "stargazerCount": 1,
    "forkCount": 3,
    "url": "https://github.com/dropbox/efivalidate",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Ruby",
        "color": "#701516"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxMjA1MzU2NjI=",
    "name": "finderinfo-rust",
    "description": undefined,
    "stargazerCount": 2,
    "forkCount": 7,
    "url": "https://github.com/dropbox/finderinfo-rust",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Rust",
        "color": "#dea584"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxMjEyOTQwMjM=",
    "name": "vizceral",
    "description": "WebGL visualization for displaying animated traffic graphs",
    "stargazerCount": 1,
    "forkCount": 5,
    "url": "https://github.com/dropbox/vizceral",
    "homepageUrl": "",
    "languages": [
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxMjc0ODAwOTc=",
    "name": "android-ui-driver",
    "description": undefined,
    "stargazerCount": 1,
    "forkCount": 0,
    "url": "https://github.com/dropbox/android-ui-driver",
    "homepageUrl": undefined,
    "languages": [],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxMzUzMDExNjg=",
    "name": "mypy-PyCharm-plugin",
    "description": "A simple plugin that allows running mypy from PyCharm and navigate between errors",
    "stargazerCount": 319,
    "forkCount": 16,
    "url": "https://github.com/dropbox/mypy-PyCharm-plugin",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Java",
        "color": "#b07219"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWNteXB5",
        "name": "mypy"
      },
      {
        "id": "MDU6VG9waWNweWNoYXJt",
        "name": "pycharm"
      },
      {
        "id": "MDU6VG9waWNweXRob24=",
        "name": "python"
      },
      {
        "id": "MDU6VG9waWN0eXBpbmc=",
        "name": "typing"
      },
      {
        "id": "MDU6VG9waWN0eXBlcw==",
        "name": "types"
      },
      {
        "id": "MDU6VG9waWN0eXBlLWNoZWNraW5n",
        "name": "type-checking"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxNDA3NzU2MTk=",
    "name": "lepton-mux",
    "description": undefined,
    "stargazerCount": 2,
    "forkCount": 1,
    "url": "https://github.com/dropbox/lepton-mux",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Rust",
        "color": "#dea584"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxNDI2MzMwMTA=",
    "name": "gallerywithtagstutorial",
    "description": undefined,
    "stargazerCount": 9,
    "forkCount": 7,
    "url": "https://github.com/dropbox/gallerywithtagstutorial",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      },
      {
        "name": "CSS",
        "color": "#663399"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxNDM4OTYyNjY=",
    "name": "sqlalchemy-stubs",
    "description": "Mypy plugin and stubs for SQLAlchemy",
    "stargazerCount": 581,
    "forkCount": 99,
    "url": "https://github.com/dropbox/sqlalchemy-stubs",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWN0eXBlcw==",
        "name": "types"
      },
      {
        "id": "MDU6VG9waWN0eXBpbmc=",
        "name": "typing"
      },
      {
        "id": "MDU6VG9waWNzdHVicw==",
        "name": "stubs"
      },
      {
        "id": "MDU6VG9waWNteXB5",
        "name": "mypy"
      },
      {
        "id": "MDU6VG9waWNweXRob24=",
        "name": "python"
      },
      {
        "id": "MDU6VG9waWNzcWw=",
        "name": "sql"
      },
      {
        "id": "MDU6VG9waWNzcWxhbGNoZW15",
        "name": "sqlalchemy"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxNDQwNTA0NjM=",
    "name": "kagome",
    "description": "Self-contained Japanese Morphological Analyzer written in pure Go",
    "stargazerCount": 1,
    "forkCount": 3,
    "url": "https://github.com/dropbox/kagome",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "Go",
        "color": "#00ADD8"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxNDkxNjQ3NTU=",
    "name": "kafka-python",
    "description": "Python client for Apache Kafka",
    "stargazerCount": 2,
    "forkCount": 3,
    "url": "https://github.com/dropbox/kafka-python",
    "homepageUrl": "http://kafka-python.readthedocs.io/",
    "languages": [
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxNDk3OTk5ODI=",
    "name": "foundationdb",
    "description": "FoundationDB - the open source, distributed, transactional key-value store",
    "stargazerCount": 4,
    "forkCount": 1,
    "url": "https://github.com/dropbox/foundationdb",
    "homepageUrl": "https://www.foundationdb.org",
    "languages": [
      {
        "name": "C++",
        "color": "#f34b7d"
      },
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "C",
        "color": "#555555"
      },
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      },
      {
        "name": "CSS",
        "color": "#663399"
      },
      {
        "name": "Go",
        "color": "#00ADD8"
      },
      {
        "name": "Java",
        "color": "#b07219"
      },
      {
        "name": "Ruby",
        "color": "#701516"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxNTA0Mzc0NDc=",
    "name": "slack",
    "description": "Slack API in Go",
    "stargazerCount": 2,
    "forkCount": 3,
    "url": "https://github.com/dropbox/slack",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Go",
        "color": "#00ADD8"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxNTEyNTUyNDU=",
    "name": "vizceral-react",
    "description": undefined,
    "stargazerCount": 1,
    "forkCount": 2,
    "url": "https://github.com/dropbox/vizceral-react",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      },
      {
        "name": "CSS",
        "color": "#663399"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxNTEyNTU0MzM=",
    "name": "vizceral-example",
    "description": "Example Vizceral app",
    "stargazerCount": 1,
    "forkCount": 0,
    "url": "https://github.com/dropbox/vizceral-example",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Dockerfile",
        "color": "#384d54"
      },
      {
        "name": "CSS",
        "color": "#663399"
      },
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxNTE2MDk0MjY=",
    "name": "Developer-Samples",
    "description": undefined,
    "stargazerCount": 14,
    "forkCount": 6,
    "url": "https://github.com/dropbox/Developer-Samples",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      },
      {
        "name": "Handlebars",
        "color": "#f7931e"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      },
      {
        "name": "CSS",
        "color": "#663399"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxNTQzOTkwNjE=",
    "name": "load_management",
    "description": "This repository contains Go utilities for managing isolation and improving reliability of multi-tenant systems.",
    "stargazerCount": 54,
    "forkCount": 15,
    "url": "https://github.com/dropbox/load_management",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Go",
        "color": "#00ADD8"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWNnbw==",
        "name": "go"
      },
      {
        "id": "MDU6VG9waWN0aHJvdHRsaW5n",
        "name": "throttling"
      },
      {
        "id": "MDU6VG9waWNhZG1pc3Npb24tY29udHJvbGxlcg==",
        "name": "admission-controller"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxNTY1Nzg3Mzg=",
    "name": "plasmic",
    "description": undefined,
    "stargazerCount": 1,
    "forkCount": 3,
    "url": "https://github.com/dropbox/plasmic",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "HTML",
        "color": "#e34c26"
      },
      {
        "name": "TypeScript",
        "color": "#3178c6"
      },
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxNTk1Mzc4OTY=",
    "name": "ts-transform-import-path-rewrite",
    "description": "TS AST transformer to rewrite import path",
    "stargazerCount": 129,
    "forkCount": 15,
    "url": "https://github.com/dropbox/ts-transform-import-path-rewrite",
    "homepageUrl": "",
    "languages": [
      {
        "name": "TypeScript",
        "color": "#3178c6"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWN0eXBlc2NyaXB0",
        "name": "typescript"
      },
      {
        "id": "MDU6VG9waWNjb21waWxlcg==",
        "name": "compiler"
      },
      {
        "id": "MDU6VG9waWNhc3Q=",
        "name": "ast"
      },
      {
        "id": "MDU6VG9waWN0cmFuc2Zvcm0=",
        "name": "transform"
      },
      {
        "id": "MDU6VG9waWNpbXBvcnQ=",
        "name": "import"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxNjAzOTc0MzM=",
    "name": "typed-css-modules-webpack-plugin",
    "description": "Generate TypeScript typing declarations for your TypeScript + CSS Modules project.",
    "stargazerCount": 69,
    "forkCount": 16,
    "url": "https://github.com/dropbox/typed-css-modules-webpack-plugin",
    "homepageUrl": "",
    "languages": [
      {
        "name": "TypeScript",
        "color": "#3178c6"
      },
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      },
      {
        "name": "CSS",
        "color": "#663399"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWNjc3M=",
        "name": "css"
      },
      {
        "id": "MDU6VG9waWN0eXBlc2NyaXB0",
        "name": "typescript"
      },
      {
        "id": "MDU6VG9waWNjc3MtbW9kdWxlcw==",
        "name": "css-modules"
      },
      {
        "id": "MDU6VG9waWN3ZWJwYWNr",
        "name": "webpack"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxNjE1NDYxNzA=",
    "name": "certificate-sync",
    "description": "Solve problems of device identity, certificates and the keychain.",
    "stargazerCount": 13,
    "forkCount": 2,
    "url": "https://github.com/dropbox/certificate-sync",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Swift",
        "color": "#F05138"
      },
      {
        "name": "C",
        "color": "#555555"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWNrZXljaGFpbg==",
        "name": "keychain"
      },
      {
        "id": "MDU6VG9waWNtYWNvcw==",
        "name": "macos"
      },
      {
        "id": "MDU6VG9waWNjZXJ0aWZpY2F0ZXM=",
        "name": "certificates"
      },
      {
        "id": "MDU6VG9waWNrZXlz",
        "name": "keys"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxNjIzMzkxNDU=",
    "name": "ts-transform-react-constant-elements",
    "description": "A TypeScript AST Transformer that can speed up reconciliation and reduce garbage collection pressure by hoisting React elements to the highest possible scope.",
    "stargazerCount": 44,
    "forkCount": 6,
    "url": "https://github.com/dropbox/ts-transform-react-constant-elements",
    "homepageUrl": "",
    "languages": [
      {
        "name": "TypeScript",
        "color": "#3178c6"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWN0eXBlc2NyaXB0",
        "name": "typescript"
      },
      {
        "id": "MDU6VG9waWN0cmFuc2Zvcm0=",
        "name": "transform"
      },
      {
        "id": "MDU6VG9waWNhc3Q=",
        "name": "ast"
      },
      {
        "id": "MDU6VG9waWNyZWFjdA==",
        "name": "react"
      },
      {
        "id": "MDU6VG9waWNjb25zdGFudA==",
        "name": "constant"
      },
      {
        "id": "MDU6VG9waWNlbGVtZW50cw==",
        "name": "elements"
      },
      {
        "id": "MDU6VG9waWNvcHRpbWl6YXRpb24=",
        "name": "optimization"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxNjQ3NDc3NzE=",
    "name": "grpc",
    "description": "The C based gRPC (C++, Python, Ruby, Objective-C, PHP, C#)",
    "stargazerCount": 4,
    "forkCount": 4,
    "url": "https://github.com/dropbox/grpc",
    "homepageUrl": "https://grpc.io",
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "CMake",
        "color": "#DA3434"
      },
      {
        "name": "Ruby",
        "color": "#701516"
      },
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "M4",
        "color": undefined
      },
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      },
      {
        "name": "C",
        "color": "#555555"
      },
      {
        "name": "C++",
        "color": "#f34b7d"
      },
      {
        "name": "Java",
        "color": "#b07219"
      },
      {
        "name": "Objective-C",
        "color": "#438eff"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxNjQ5NTI4NzM=",
    "name": "ts-transform-react-jsx-source",
    "description": "TypeScript AST Transformer that adds source file and line number to JSX elements",
    "stargazerCount": 12,
    "forkCount": 10,
    "url": "https://github.com/dropbox/ts-transform-react-jsx-source",
    "homepageUrl": "",
    "languages": [
      {
        "name": "TypeScript",
        "color": "#3178c6"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWN0eXBlc2NyaXB0",
        "name": "typescript"
      },
      {
        "id": "MDU6VG9waWN0cmFuc2Zvcm0=",
        "name": "transform"
      },
      {
        "id": "MDU6VG9waWNhc3Q=",
        "name": "ast"
      },
      {
        "id": "MDU6VG9waWNjb21waWxlcg==",
        "name": "compiler"
      },
      {
        "id": "MDU6VG9waWNyZWFjdA==",
        "name": "react"
      },
      {
        "id": "MDU6VG9waWNqc3g=",
        "name": "jsx"
      },
      {
        "id": "MDU6VG9waWNkZWJ1Zw==",
        "name": "debug"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxNjcwODk1MzA=",
    "name": "react-day-picker",
    "description": "Flexible date picker for React",
    "stargazerCount": 2,
    "forkCount": 3,
    "url": "https://github.com/dropbox/react-day-picker",
    "homepageUrl": "http://react-day-picker.js.org",
    "languages": [
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      },
      {
        "name": "CSS",
        "color": "#663399"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxNjcyMTY2NDA=",
    "name": "incubator-superset-internal",
    "description": undefined,
    "stargazerCount": 12,
    "forkCount": 10,
    "url": "https://github.com/dropbox/incubator-superset-internal",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Dockerfile",
        "color": "#384d54"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "Smarty",
        "color": "#f0c040"
      },
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      },
      {
        "name": "TypeScript",
        "color": "#3178c6"
      },
      {
        "name": "CSS",
        "color": "#663399"
      },
      {
        "name": "Mako",
        "color": "#7e858d"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      },
      {
        "name": "Makefile",
        "color": "#427819"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxNjc0NTU2MDU=",
    "name": "goebpf",
    "description": "Library to work with eBPF programs from Go",
    "stargazerCount": 1165,
    "forkCount": 86,
    "url": "https://github.com/dropbox/goebpf",
    "homepageUrl": "",
    "languages": [
      {
        "name": "C",
        "color": "#555555"
      },
      {
        "name": "Go",
        "color": "#00ADD8"
      },
      {
        "name": "Makefile",
        "color": "#427819"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWNlYnBm",
        "name": "ebpf"
      },
      {
        "id": "MDU6VG9waWNnb2xhbmc=",
        "name": "golang"
      },
      {
        "id": "MDU6VG9waWN4ZHA=",
        "name": "xdp"
      },
      {
        "id": "MDU6VG9waWNicGY=",
        "name": "bpf"
      },
      {
        "id": "MDU6VG9waWNwZXJmZXZlbnRz",
        "name": "perfevents"
      },
      {
        "id": "MDU6VG9waWNnbw==",
        "name": "go"
      },
      {
        "id": "MDU6VG9waWNnb2xhbmctbGlicmFyeQ==",
        "name": "golang-library"
      },
      {
        "id": "MDU6VG9waWN4ZHBkdW1w",
        "name": "xdpdump"
      },
      {
        "id": "MDU6VG9waWNjYXRz",
        "name": "cats"
      },
      {
        "id": "MDU6VG9waWNjYXRzLWVmZmVjdA==",
        "name": "cats-effect"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxNzgwNDI1OTE=",
    "name": "vsmc",
    "description": "Vendor Security Model Contract",
    "stargazerCount": 98,
    "forkCount": 15,
    "url": "https://github.com/dropbox/vsmc",
    "homepageUrl": undefined,
    "languages": [],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxNzkxMDc1MDc=",
    "name": "llama",
    "description": "Library for testing and measuring network loss and latency between distributed endpoints.",
    "stargazerCount": 65,
    "forkCount": 18,
    "url": "https://github.com/dropbox/llama",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Go",
        "color": "#00ADD8"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWNuZXR3b3Jr",
        "name": "network"
      },
      {
        "id": "MDU6VG9waWNtb25pdG9yaW5n",
        "name": "monitoring"
      },
      {
        "id": "MDU6VG9waWN0ZWxlbWV0cnk=",
        "name": "telemetry"
      },
      {
        "id": "MDU6VG9waWNsb3Nz",
        "name": "loss"
      },
      {
        "id": "MDU6VG9waWNsYXRlbmN5",
        "name": "latency"
      },
      {
        "id": "MDU6VG9waWNnbw==",
        "name": "go"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxODY5MDI2MzA=",
    "name": "buck",
    "description": "A fast build system that encourages the creation of small, reusable modules over a variety of platforms and languages.",
    "stargazerCount": 4,
    "forkCount": 1,
    "url": "https://github.com/dropbox/buck",
    "homepageUrl": "https://buckbuild.com",
    "languages": [
      {
        "name": "Java",
        "color": "#b07219"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "C",
        "color": "#555555"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "Batchfile",
        "color": "#C1F12E"
      },
      {
        "name": "PowerShell",
        "color": "#012456"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      },
      {
        "name": "Thrift",
        "color": "#D12127"
      },
      {
        "name": "Smalltalk",
        "color": "#596706"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkxODY5MDM1ODY=",
    "name": "hypershard-android",
    "description": "CLI tool for collecting tests",
    "stargazerCount": 85,
    "forkCount": 12,
    "url": "https://github.com/dropbox/hypershard-android",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Kotlin",
        "color": "#A97BFF"
      },
      {
        "name": "Java",
        "color": "#b07219"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWNrb3RsaW4tbGlicmFyeQ==",
        "name": "kotlin-library"
      },
      {
        "id": "MDU6VG9waWNqYXZh",
        "name": "java"
      },
      {
        "id": "MDU6VG9waWNrb3RsaW4=",
        "name": "kotlin"
      },
      {
        "id": "MDU6VG9waWNhbmRyb2lk",
        "name": "android"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkyMDM0MTk4NDg=",
    "name": "zinger",
    "description": "Python script for interacting with the Zingtree API",
    "stargazerCount": 4,
    "forkCount": 1,
    "url": "https://github.com/dropbox/zinger",
    "homepageUrl": "https://zingtree.com/api/",
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWN6aW5ndHJlZQ==",
        "name": "zingtree"
      },
      {
        "id": "MDU6VG9waWNweXRob24=",
        "name": "python"
      },
      {
        "id": "MDU6VG9waWN0cmVlcw==",
        "name": "trees"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkyMDY2ODIyOTA=",
    "name": "dropbox-sdk-rust",
    "description": "Dropbox SDK for Rust",
    "stargazerCount": 86,
    "forkCount": 18,
    "url": "https://github.com/dropbox/dropbox-sdk-rust",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "Rust",
        "color": "#dea584"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkyMDk5MDExNTE=",
    "name": "grafana-report-panel",
    "description": undefined,
    "stargazerCount": 1,
    "forkCount": 1,
    "url": "https://github.com/dropbox/grafana-report-panel",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "TypeScript",
        "color": "#3178c6"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkyMTM5Njg2ODY=",
    "name": "hypershard-ios",
    "description": "⚡ the ridiculously fast XCUITest collector.",
    "stargazerCount": 24,
    "forkCount": 2,
    "url": "https://github.com/dropbox/hypershard-ios",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Swift",
        "color": "#F05138"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWNpb3M=",
        "name": "ios"
      },
      {
        "id": "MDU6VG9waWN0ZXN0aW5n",
        "name": "testing"
      },
      {
        "id": "MDU6VG9waWN4Y3VpdGVzdA==",
        "name": "xcuitest"
      },
      {
        "id": "MDU6VG9waWNzd2lmdA==",
        "name": "swift"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkyMTY2ODg0NDM=",
    "name": "hbase",
    "description": "Mirror of Apache Hadoop HBase",
    "stargazerCount": 1,
    "forkCount": 1,
    "url": "https://github.com/dropbox/hbase",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Ruby",
        "color": "#701516"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "Java",
        "color": "#b07219"
      },
      {
        "name": "C++",
        "color": "#f34b7d"
      },
      {
        "name": "PHP",
        "color": "#4F5D95"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "CSS",
        "color": "#663399"
      },
      {
        "name": "XSLT",
        "color": "#EB8CEB"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkyMjcyNTAxMDg=",
    "name": "dbx_build_tools",
    "description": "Dropbox's Bazel rules and tools",
    "stargazerCount": 211,
    "forkCount": 36,
    "url": "https://github.com/dropbox/dbx_build_tools",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "C",
        "color": "#555555"
      },
      {
        "name": "Go",
        "color": "#00ADD8"
      },
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "Dockerfile",
        "color": "#384d54"
      },
      {
        "name": "Starlark",
        "color": "#76d275"
      },
      {
        "name": "C++",
        "color": "#f34b7d"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWNiYXplbA==",
        "name": "bazel"
      },
      {
        "id": "MDU6VG9waWNweXRob24=",
        "name": "python"
      },
      {
        "id": "MDU6VG9waWNiYXplbC1ydWxlcw==",
        "name": "bazel-rules"
      },
      {
        "id": "MDU6VG9waWNzdGFybGFyaw==",
        "name": "starlark"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkyMzE0NjcxMjE=",
    "name": "kglb",
    "description": "KgLb - L4 Load Balancer",
    "stargazerCount": 154,
    "forkCount": 13,
    "url": "https://github.com/dropbox/kglb",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Go",
        "color": "#00ADD8"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkyMzczMDkyNjU=",
    "name": "protobuf.js",
    "description": "Protocol Buffers for JavaScript (& TypeScript).",
    "stargazerCount": 3,
    "forkCount": 2,
    "url": "https://github.com/dropbox/protobuf.js",
    "homepageUrl": "",
    "languages": [
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      },
      {
        "name": "TypeScript",
        "color": "#3178c6"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkyNDM4NjQzOTU=",
    "name": "fast_rsync",
    "description": "An optimized implementation of librsync in pure Rust.",
    "stargazerCount": 662,
    "forkCount": 40,
    "url": "https://github.com/dropbox/fast_rsync",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Rust",
        "color": "#dea584"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkyNDU1MzI5Mjc=",
    "name": "ykfipsconf",
    "description": "Yubikey Bulk Provisioning tool specifically for FIPS series keys.",
    "stargazerCount": 4,
    "forkCount": 1,
    "url": "https://github.com/dropbox/ykfipsconf",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkyNjE4MjE5ODU=",
    "name": "altgrpc",
    "description": "alternate gRPC",
    "stargazerCount": 7,
    "forkCount": 3,
    "url": "https://github.com/dropbox/altgrpc",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Starlark",
        "color": "#76d275"
      },
      {
        "name": "C++",
        "color": "#f34b7d"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkyNzYyNjQ1MTU=",
    "name": "eslint-formatter-arcanist",
    "description": "Transforms ESLint JSON output to Arcanist so it can be used with any generic arc linter",
    "stargazerCount": 3,
    "forkCount": 2,
    "url": "https://github.com/dropbox/eslint-formatter-arcanist",
    "homepageUrl": "",
    "languages": [
      {
        "name": "TypeScript",
        "color": "#3178c6"
      },
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWNlc2xpbnQ=",
        "name": "eslint"
      },
      {
        "id": "MDU6VG9waWNmb3JtYXR0ZXI=",
        "name": "formatter"
      },
      {
        "id": "MDU6VG9waWNhcmNhbmlzdA==",
        "name": "arcanist"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkyNzkzODE1MTA=",
    "name": "pb-jelly",
    "description": "A protobuf code generation framework for the Rust language developed at Dropbox.",
    "stargazerCount": 612,
    "forkCount": 26,
    "url": "https://github.com/dropbox/pb-jelly",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Rust",
        "color": "#dea584"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWNydXN0",
        "name": "rust"
      },
      {
        "id": "MDU6VG9waWNwcm90b2J1Zg==",
        "name": "protobuf"
      },
      {
        "id": "MDU6VG9waWNkcm9wYm94",
        "name": "dropbox"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkyODU5MjM4MDE=",
    "name": "setsum",
    "description": undefined,
    "stargazerCount": 10,
    "forkCount": 2,
    "url": "https://github.com/dropbox/setsum",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Rust",
        "color": "#dea584"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkyOTM5MjUxNDE=",
    "name": "lightSAML",
    "description": "SAML 2.0 PHP Library",
    "stargazerCount": 3,
    "forkCount": 3,
    "url": "https://github.com/dropbox/lightSAML",
    "homepageUrl": "https://www.lightsaml.com/LightSAML-Core/",
    "languages": [
      {
        "name": "PHP",
        "color": "#4F5D95"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkyOTc3OTMxNDc=",
    "name": "AffectedModuleDetector",
    "description": "A Gradle Plugin to determine which modules were affected by a set of files in a commit. ",
    "stargazerCount": 646,
    "forkCount": 49,
    "url": "https://github.com/dropbox/AffectedModuleDetector",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Kotlin",
        "color": "#A97BFF"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkyOTk5OTIyNjg=",
    "name": "kaiken",
    "description": "User scoping library for Android applications.",
    "stargazerCount": 71,
    "forkCount": 12,
    "url": "https://github.com/dropbox/kaiken",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Kotlin",
        "color": "#A97BFF"
      },
      {
        "name": "Java",
        "color": "#b07219"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkzMDIxMjQ1MzM=",
    "name": "hellosign-developer-samples",
    "description": undefined,
    "stargazerCount": 2,
    "forkCount": 4,
    "url": "https://github.com/dropbox/hellosign-developer-samples",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      },
      {
        "name": "CSS",
        "color": "#663399"
      },
      {
        "name": "Handlebars",
        "color": "#f7931e"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkzMDY3MTQ1ODI=",
    "name": "airflow",
    "description": "Apache Airflow - A platform to programmatically author, schedule, and monitor workflows",
    "stargazerCount": 2,
    "forkCount": 2,
    "url": "https://github.com/dropbox/airflow",
    "homepageUrl": "https://airflow.apache.org/",
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      },
      {
        "name": "CSS",
        "color": "#663399"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "Mako",
        "color": "#7e858d"
      },
      {
        "name": "Jupyter Notebook",
        "color": "#DA5B0B"
      },
      {
        "name": "Dockerfile",
        "color": "#384d54"
      },
      {
        "name": "HCL",
        "color": "#844FBA"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkzMTQ2ODg3NjU=",
    "name": "amundsen",
    "description": "Amundsen is a metadata driven application for improving the productivity of data analysts, data scientists and engineers when interacting with data.",
    "stargazerCount": 1,
    "forkCount": 1,
    "url": "https://github.com/dropbox/amundsen",
    "homepageUrl": "https://www.amundsen.io/amundsen/",
    "languages": [
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkzMTQ2ODg4NjA=",
    "name": "amundsenfrontendlibrary",
    "description": "Front-end service library for Amundsen",
    "stargazerCount": 1,
    "forkCount": 0,
    "url": "https://github.com/dropbox/amundsenfrontendlibrary",
    "homepageUrl": "https://github.com/amundsen-io/amundsen",
    "languages": [
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "TypeScript",
        "color": "#3178c6"
      },
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      },
      {
        "name": "Dockerfile",
        "color": "#384d54"
      },
      {
        "name": "SCSS",
        "color": "#c6538c"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkzMTQ2ODg4OTk=",
    "name": "amundsendatabuilder",
    "description": "Data ingestion library for Amundsen to build graph and search index",
    "stargazerCount": 1,
    "forkCount": 0,
    "url": "https://github.com/dropbox/amundsendatabuilder",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkzMTQ2ODg5Mzk=",
    "name": "amundsenmetadatalibrary",
    "description": "Metadata service library for Amundsen",
    "stargazerCount": 1,
    "forkCount": 0,
    "url": "https://github.com/dropbox/amundsenmetadatalibrary",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "Dockerfile",
        "color": "#384d54"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkzMTQ2ODg5ODY=",
    "name": "amundsencommon",
    "description": "Amundsen library to place common code for Amundsen microservices to share",
    "stargazerCount": 1,
    "forkCount": 0,
    "url": "https://github.com/dropbox/amundsencommon",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkzMTQ2ODkwMjM=",
    "name": "amundsensearchlibrary",
    "description": "Search service library for Amundsen",
    "stargazerCount": 1,
    "forkCount": 0,
    "url": "https://github.com/dropbox/amundsensearchlibrary",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Dockerfile",
        "color": "#384d54"
      },
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkzMjA0MDg0NTc=",
    "name": "GPO-Templates",
    "description": "template for client settings",
    "stargazerCount": 3,
    "forkCount": 2,
    "url": "https://github.com/dropbox/GPO-Templates",
    "homepageUrl": undefined,
    "languages": [],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkzMjE3NjEyMTQ=",
    "name": "SwipeCellKit",
    "description": "Swipeable UITableViewCell/UICollectionViewCell based on the stock Mail.app, implemented in Swift.",
    "stargazerCount": 1,
    "forkCount": 1,
    "url": "https://github.com/dropbox/SwipeCellKit",
    "homepageUrl": "https://jerkoch.com/2017/02/07/swiper-no-swiping.html",
    "languages": [
      {
        "name": "Swift",
        "color": "#F05138"
      },
      {
        "name": "Objective-C",
        "color": "#438eff"
      },
      {
        "name": "Ruby",
        "color": "#701516"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkzNDE3MDkzMzY=",
    "name": "kondo",
    "description": "A tool to automate code refactors and modularization",
    "stargazerCount": 7,
    "forkCount": 4,
    "url": "https://github.com/dropbox/kondo",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Swift",
        "color": "#F05138"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "MDEwOlJlcG9zaXRvcnkzNzU1MTcyMTY=",
    "name": "dbx-career-framework",
    "description": undefined,
    "stargazerCount": 92,
    "forkCount": 33,
    "url": "https://github.com/dropbox/dbx-career-framework",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "R_kgDOGXVf_w",
    "name": "esaml",
    "description": "Erlang SAML library, SSO and SLO, with Cowboy integration",
    "stargazerCount": 23,
    "forkCount": 19,
    "url": "https://github.com/dropbox/esaml",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Erlang",
        "color": "#B83998"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "R_kgDOGXVhgw",
    "name": "samly",
    "description": "Elixir Plug library to enable SAML 2.0 SP SSO in Phoenix/Plug applications.",
    "stargazerCount": 71,
    "forkCount": 39,
    "url": "https://github.com/dropbox/samly",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Elixir",
        "color": "#6e4a7e"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "R_kgDOGvhHLQ",
    "name": "differ",
    "description": undefined,
    "stargazerCount": 79,
    "forkCount": 5,
    "url": "https://github.com/dropbox/differ",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Kotlin",
        "color": "#A97BFF"
      },
      {
        "name": "C++",
        "color": "#f34b7d"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "R_kgDOGzetgw",
    "name": "focus",
    "description": "A Gradle plugin that helps you speed up builds by excluding unnecessary modules.",
    "stargazerCount": 424,
    "forkCount": 25,
    "url": "https://github.com/dropbox/focus",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Kotlin",
        "color": "#A97BFF"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWNncmFkbGU=",
        "name": "gradle"
      },
      {
        "id": "MDU6VG9waWNncmFkbGUtcGx1Z2lu",
        "name": "gradle-plugin"
      },
      {
        "id": "MDU6VG9waWNhbmRyb2lk",
        "name": "android"
      },
      {
        "id": "MDU6VG9waWNidWlsZA==",
        "name": "build"
      },
      {
        "id": "MDU6VG9waWNidWlsZC10b29s",
        "name": "build-tool"
      },
      {
        "id": "MDU6VG9waWNidWlsZC1wZXJmb3JtYW5jZQ==",
        "name": "build-performance"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "R_kgDOG49CPA",
    "name": "lunasec",
    "description": "LunaSec - Open Source Security Software built by Security Engineers. Scan your dependencies for Log4Shell, or add Data Tokenization to prevent data leaks. Try our live Tokenizer demo: https://app.lunasec.dev",
    "stargazerCount": 0,
    "forkCount": 2,
    "url": "https://github.com/dropbox/lunasec",
    "homepageUrl": "https://www.lunasec.io/",
    "languages": [
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      },
      {
        "name": "CSS",
        "color": "#663399"
      },
      {
        "name": "Pug",
        "color": "#a86454"
      },
      {
        "name": "TypeScript",
        "color": "#3178c6"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "Dockerfile",
        "color": "#384d54"
      },
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "Go",
        "color": "#00ADD8"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "R_kgDOG7CkEQ",
    "name": "componentbox",
    "description": "Reactive server-driven UI for iOS, Android, and web",
    "stargazerCount": 261,
    "forkCount": 7,
    "url": "https://github.com/dropbox/componentbox",
    "homepageUrl": "https://dropbox.github.io/componentbox/",
    "languages": [
      {
        "name": "Kotlin",
        "color": "#A97BFF"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWNrb3RsaW4tbXVsdGlwbGF0Zm9ybQ==",
        "name": "kotlin-multiplatform"
      },
      {
        "id": "MDU6VG9waWNzZXJ2ZXItZHJpdmVuLXVp",
        "name": "server-driven-ui"
      },
      {
        "id": "MDU6VG9waWNhbmRyb2lk",
        "name": "android"
      },
      {
        "id": "MDU6VG9waWNpb3M=",
        "name": "ios"
      },
      {
        "id": "MDU6VG9waWNjb21wb3Nl",
        "name": "compose"
      },
      {
        "id": "MDU6VG9waWNqZXRwYWNr",
        "name": "jetpack"
      },
      {
        "id": "MDU6VG9waWNyZWFjdA==",
        "name": "react"
      },
      {
        "id": "MDU6VG9waWNzd2lmdC11aQ==",
        "name": "swift-ui"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "R_kgDOG-BEaw",
    "name": "ttvc",
    "description": "Measure Visually Complete metrics in real time",
    "stargazerCount": 45,
    "forkCount": 13,
    "url": "https://github.com/dropbox/ttvc",
    "homepageUrl": "https://www.npmjs.com/package/@dropbox/ttvc",
    "languages": [
      {
        "name": "TypeScript",
        "color": "#3178c6"
      },
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      },
      {
        "name": "CSS",
        "color": "#663399"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWNwZXJmb3JtYW5jZQ==",
        "name": "performance"
      },
      {
        "id": "MDU6VG9waWN1c2VyLWNlbnRyaWMtbWV0cmljcw==",
        "name": "user-centric-metrics"
      },
      {
        "id": "MDU6VG9waWN3ZWItcGVyZm9ybWFuY2U=",
        "name": "web-performance"
      },
      {
        "id": "MDU6VG9waWN3ZWItdml0YWxz",
        "name": "web-vitals"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "R_kgDOHAI8Bw",
    "name": "dependency-guard",
    "description": "A Gradle plugin that guards against unintentional dependency changes.",
    "stargazerCount": 480,
    "forkCount": 19,
    "url": "https://github.com/dropbox/dependency-guard",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Kotlin",
        "color": "#A97BFF"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWNhbmRyb2lk",
        "name": "android"
      },
      {
        "id": "MDU6VG9waWNidWlsZA==",
        "name": "build"
      },
      {
        "id": "MDU6VG9waWNidWlsZC10b29s",
        "name": "build-tool"
      },
      {
        "id": "MDU6VG9waWNkZXBlbmRlbmNpZXM=",
        "name": "dependencies"
      },
      {
        "id": "MDU6VG9waWNncmFkbGU=",
        "name": "gradle"
      },
      {
        "id": "MDU6VG9waWNncmFkbGUtcGx1Z2lu",
        "name": "gradle-plugin"
      },
      {
        "id": "MDU6VG9waWNkZXBlbmRlbmN5LWd1YXJk",
        "name": "dependency-guard"
      },
      {
        "id": "MDU6VG9waWNrb3RsaW4=",
        "name": "kotlin"
      },
      {
        "id": "MDU6VG9waWNrb3RsaW4tZHNs",
        "name": "kotlin-dsl"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "R_kgDOHZUvkQ",
    "name": "dropshots",
    "description": "Easy on-device screenshot testing for Android.",
    "stargazerCount": 283,
    "forkCount": 19,
    "url": "https://github.com/dropbox/dropshots",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Kotlin",
        "color": "#A97BFF"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWNhbmRyb2lk",
        "name": "android"
      },
      {
        "id": "MDU6VG9waWNncmFkbGUtcGx1Z2lu",
        "name": "gradle-plugin"
      },
      {
        "id": "MDU6VG9waWN0ZXN0aW5n",
        "name": "testing"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "R_kgDOHg4l6w",
    "name": "eslint-plugin-service-worker",
    "description": "ESLint plugin for service worker environment.",
    "stargazerCount": 1,
    "forkCount": 2,
    "url": "https://github.com/dropbox/eslint-plugin-service-worker",
    "homepageUrl": "",
    "languages": [
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "R_kgDOHi8gUg",
    "name": "rules_rust",
    "description": "Rust rules for Bazel",
    "stargazerCount": 0,
    "forkCount": 1,
    "url": "https://github.com/dropbox/rules_rust",
    "homepageUrl": "https://bazelbuild.github.io/rules_rust/",
    "languages": [
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "C++",
        "color": "#f34b7d"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "C",
        "color": "#555555"
      },
      {
        "name": "Rust",
        "color": "#dea584"
      },
      {
        "name": "Starlark",
        "color": "#76d275"
      },
      {
        "name": "Jinja",
        "color": "#a52a22"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "R_kgDOIpU8dQ",
    "name": "graphql-dataloader-activerecord",
    "description": undefined,
    "stargazerCount": 10,
    "forkCount": 0,
    "url": "https://github.com/dropbox/graphql-dataloader-activerecord",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Ruby",
        "color": "#701516"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "R_kgDOIxItPw",
    "name": "java-code-styles",
    "description": "IntelliJ IDEA code style settings for Square's Java and Android projects.",
    "stargazerCount": 0,
    "forkCount": 0,
    "url": "https://github.com/dropbox/java-code-styles",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "Batchfile",
        "color": "#C1F12E"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "R_kgDOI8Brug",
    "name": "libsodium.js",
    "description": "libsodium compiled to Webassembly and pure JavaScript, with convenient wrappers. - Dropbox Fork",
    "stargazerCount": 0,
    "forkCount": 0,
    "url": "https://github.com/dropbox/libsodium.js",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      },
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "R_kgDOI8BtoA",
    "name": "libsodium",
    "description": "A modern, portable, easy to use crypto library.",
    "stargazerCount": 0,
    "forkCount": 0,
    "url": "https://github.com/dropbox/libsodium",
    "homepageUrl": "https://libsodium.org",
    "languages": [
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "C",
        "color": "#555555"
      },
      {
        "name": "PHP",
        "color": "#4F5D95"
      },
      {
        "name": "C#",
        "color": "#178600"
      },
      {
        "name": "Assembly",
        "color": "#6E4C13"
      },
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "Smarty",
        "color": "#f0c040"
      },
      {
        "name": "Batchfile",
        "color": "#C1F12E"
      },
      {
        "name": "M4",
        "color": undefined
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "R_kgDOJWf9Gg",
    "name": "forester",
    "description": "Mapping out the forest",
    "stargazerCount": 10,
    "forkCount": 0,
    "url": "https://github.com/dropbox/forester",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Kotlin",
        "color": "#A97BFF"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "R_kgDOKCClbA",
    "name": "llm-security",
    "description": "Dropbox LLM Security research code and results",
    "stargazerCount": 246,
    "forkCount": 31,
    "url": "https://github.com/dropbox/llm-security",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "TO_kgCjbGxt",
        "name": "llm"
      },
      {
        "id": "TO_kgCwcHJvbXB0LWluamVjdGlvbg",
        "name": "prompt-injection"
      },
      {
        "id": "MDU6VG9waWNzZWN1cml0eQ==",
        "name": "security"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "R_kgDOKfzAaA",
    "name": "low-rank-llama2",
    "description": "Low-Rank Llama Custom Training",
    "stargazerCount": 23,
    "forkCount": 2,
    "url": "https://github.com/dropbox/low-rank-llama2",
    "homepageUrl": "https://mobiusml.github.io/low-rank-llama2/",
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      },
      {
        "name": "CSS",
        "color": "#663399"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "R_kgDOKiaNSg",
    "name": "aana_sdk",
    "description": "Aana SDK is a powerful framework for building AI enabled multimodal applications.",
    "stargazerCount": 53,
    "forkCount": 8,
    "url": "https://github.com/dropbox/aana_sdk",
    "homepageUrl": "https://www.mobiuslabs.com/",
    "languages": [
      {
        "name": "Dockerfile",
        "color": "#384d54"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "Jinja",
        "color": "#a52a22"
      },
      {
        "name": "Mako",
        "color": "#7e858d"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWNhaQ==",
        "name": "ai"
      },
      {
        "id": "TO_kgCjbGxt",
        "name": "llm"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "R_kgDOKknOGw",
    "name": "swift-snapshot-testing",
    "description": "📸 Delightful Swift snapshot testing.",
    "stargazerCount": 0,
    "forkCount": 0,
    "url": "https://github.com/dropbox/swift-snapshot-testing",
    "homepageUrl": "https://www.pointfree.co/episodes/ep41-a-tour-of-snapshot-testing",
    "languages": [
      {
        "name": "Swift",
        "color": "#F05138"
      },
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      },
      {
        "name": "Roff",
        "color": "#ecdebe"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "R_kgDOKqnoLA",
    "name": "hqq",
    "description": "Official implementation of Half-Quadratic Quantization (HQQ)",
    "stargazerCount": 894,
    "forkCount": 88,
    "url": "https://github.com/dropbox/hqq",
    "homepageUrl": "https://dropbox.github.io/hqq_blog/",
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "C++",
        "color": "#f34b7d"
      },
      {
        "name": "Cuda",
        "color": "#3A4E3A"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWNtYWNoaW5lLWxlYXJuaW5n",
        "name": "machine-learning"
      },
      {
        "id": "MDU6VG9waWNxdWFudGl6YXRpb24=",
        "name": "quantization"
      },
      {
        "id": "TO_kgCjbGxt",
        "name": "llm"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "R_kgDOK7Pnhw",
    "name": "rules_apple",
    "description": "Bazel rules to build apps for Apple platforms.",
    "stargazerCount": 0,
    "forkCount": 0,
    "url": "https://github.com/dropbox/rules_apple",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "C++",
        "color": "#f34b7d"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "C",
        "color": "#555555"
      },
      {
        "name": "Objective-C",
        "color": "#438eff"
      },
      {
        "name": "Swift",
        "color": "#F05138"
      },
      {
        "name": "DTrace",
        "color": undefined
      },
      {
        "name": "Metal",
        "color": "#8f14e9"
      },
      {
        "name": "Starlark",
        "color": "#76d275"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "R_kgDOK99EBA",
    "name": "delta",
    "description": "An open-source storage framework that enables building a Lakehouse architecture with compute engines including Spark, PrestoDB, Flink, Trino, and Hive and APIs",
    "stargazerCount": 1,
    "forkCount": 0,
    "url": "https://github.com/dropbox/delta",
    "homepageUrl": "https://delta.io",
    "languages": [
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "Java",
        "color": "#b07219"
      },
      {
        "name": "Scala",
        "color": "#c22d40"
      },
      {
        "name": "CSS",
        "color": "#663399"
      },
      {
        "name": "ANTLR",
        "color": "#9DC3FF"
      },
      {
        "name": "HTML",
        "color": "#e34c26"
      },
      {
        "name": "HCL",
        "color": "#844FBA"
      },
      {
        "name": "Dockerfile",
        "color": "#384d54"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "R_kgDOLaZi9Q",
    "name": "bhakti",
    "description": "Bundle of security analysis scripts for keras tensorflow models ",
    "stargazerCount": 14,
    "forkCount": 0,
    "url": "https://github.com/dropbox/bhakti",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "Batchfile",
        "color": "#C1F12E"
      },
      {
        "name": "YARA",
        "color": "#220000"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWNjZGs=",
        "name": "cdk"
      },
      {
        "id": "MDU6VG9waWNweXRob24=",
        "name": "python"
      },
      {
        "id": "MDU6VG9waWNzZWN1cml0eQ==",
        "name": "security"
      },
      {
        "id": "MDU6VG9waWN5YXJhLXJ1bGVz",
        "name": "yara-rules"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "R_kgDOLdN1yw",
    "name": "external-provisioner",
    "description": "Sidecar container that watches Kubernetes PersistentVolumeClaim objects and triggers CreateVolume/DeleteVolume against a CSI endpoint",
    "stargazerCount": 0,
    "forkCount": 0,
    "url": "https://github.com/dropbox/external-provisioner",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "Ruby",
        "color": "#701516"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "Go",
        "color": "#00ADD8"
      },
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "Dockerfile",
        "color": "#384d54"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "R_kgDOMBEFLA",
    "name": "whisper-static-cache-blog",
    "description": undefined,
    "stargazerCount": 0,
    "forkCount": 0,
    "url": "https://github.com/dropbox/whisper-static-cache-blog",
    "homepageUrl": "https://mobiusml.github.io/whisper-static-cache-blog/",
    "languages": [
      {
        "name": "HTML",
        "color": "#e34c26"
      },
      {
        "name": "CSS",
        "color": "#663399"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "R_kgDOMFf5mQ",
    "name": "certificate-pins",
    "description": undefined,
    "stargazerCount": 0,
    "forkCount": 1,
    "url": "https://github.com/dropbox/certificate-pins",
    "homepageUrl": undefined,
    "languages": [],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "R_kgDOMMUh2g",
    "name": "aana_app_template",
    "description": "A template for applications built on top of Aana SDK",
    "stargazerCount": 0,
    "forkCount": 0,
    "url": "https://github.com/dropbox/aana_app_template",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Dockerfile",
        "color": "#384d54"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "Jinja",
        "color": "#a52a22"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "R_kgDOMRbQpg",
    "name": "gemlite",
    "description": "Fast low-bit matmul kernels in Triton",
    "stargazerCount": 401,
    "forkCount": 29,
    "url": "https://github.com/dropbox/gemlite",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "R_kgDOMR1gHA",
    "name": "aana-sdk-introducing-blog",
    "description": undefined,
    "stargazerCount": 0,
    "forkCount": 0,
    "url": "https://github.com/dropbox/aana-sdk-introducing-blog",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "HTML",
        "color": "#e34c26"
      },
      {
        "name": "CSS",
        "color": "#663399"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "R_kgDOMUAVTA",
    "name": "aana_chat_with_video",
    "description": "A multimodal chat application that allows users to upload a video and ask questions about the video content based on the visual and audio information.",
    "stargazerCount": 1,
    "forkCount": 0,
    "url": "https://github.com/dropbox/aana_chat_with_video",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Dockerfile",
        "color": "#384d54"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "Jinja",
        "color": "#a52a22"
      },
      {
        "name": "Mako",
        "color": "#7e858d"
      },
      {
        "name": "Shell",
        "color": "#89e051"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "R_kgDOMc_tPg",
    "name": "aana_summarize_video",
    "description": "An Aana application that summarizes a video by extracting transcription from the audio and generating a summary using a Language Model (LLM).",
    "stargazerCount": 1,
    "forkCount": 0,
    "url": "https://github.com/dropbox/aana_summarize_video",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "Dockerfile",
        "color": "#384d54"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "Jinja",
        "color": "#a52a22"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "R_kgDOMfalYA",
    "name": "aana_examples",
    "description": "Example applications for Aana SDK",
    "stargazerCount": 1,
    "forkCount": 0,
    "url": "https://github.com/dropbox/aana_examples",
    "homepageUrl": undefined,
    "languages": [],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "R_kgDOM6Eecg",
    "name": "humiscript",
    "description": undefined,
    "stargazerCount": 1,
    "forkCount": 0,
    "url": "https://github.com/dropbox/humiscript",
    "homepageUrl": undefined,
    "languages": [],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "R_kgDON-8HFQ",
    "name": "StoreKitTestHelpers",
    "description": "StoreKitTestHelpers is a little utility to help reduce test flakiness when using StoreKitTest",
    "stargazerCount": 5,
    "forkCount": 0,
    "url": "https://github.com/dropbox/StoreKitTestHelpers",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Swift",
        "color": "#F05138"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWNzdG9yZWtpdA==",
        "name": "storekit"
      },
      {
        "id": "TO_kgCsc3RvcmVraXR0ZXN0",
        "name": "storekittest"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "R_kgDOOd6x3A",
    "name": "RxPublished",
    "description": "RxPublished: a drop-in RxSwift replacement for Published within ObservableObject ViewModels",
    "stargazerCount": 8,
    "forkCount": 0,
    "url": "https://github.com/dropbox/RxPublished",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Swift",
        "color": "#F05138"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWNjb21iaW5l",
        "name": "combine"
      },
      {
        "id": "MDU6VG9waWNyeHN3aWZ0",
        "name": "rxswift"
      },
      {
        "id": "MDU6VG9waWNzd2lmdA==",
        "name": "swift"
      },
      {
        "id": "MDU6VG9waWNzd2lmdHVp",
        "name": "swiftui"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "R_kgDOPJh3Dw",
    "name": "aana_image_redoc",
    "description": undefined,
    "stargazerCount": 0,
    "forkCount": 0,
    "url": "https://github.com/dropbox/aana_image_redoc",
    "homepageUrl": undefined,
    "languages": [
      {
        "name": "HTML",
        "color": "#e34c26"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "R_kgDOPRBgpg",
    "name": "akeyless-buildkite-plugin",
    "description": "Akeyless plugin for Buildkite",
    "stargazerCount": 2,
    "forkCount": 0,
    "url": "https://github.com/dropbox/akeyless-buildkite-plugin",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Shell",
        "color": "#89e051"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      }
    ],
    "contributors": [],
    "topics": [
      {
        "id": "MDU6VG9waWNidWlsZGtpdGUtcGx1Z2lu",
        "name": "buildkite-plugin"
      },
      {
        "id": "MDU6VG9waWNha2V5bGVzcw==",
        "name": "akeyless"
      },
      {
        "id": "TO_kgCtc2VjcmV0LWFjY2Vzcw",
        "name": "secret-access"
      }
    ],
    "owner": "dropbox"
  },
  {
    "id": "R_kgDOP2pdjg",
    "name": "app-store-server-library-python",
    "description": "The Python server library for the App Store Server API and App Store Server Notifications.",
    "stargazerCount": 0,
    "forkCount": 0,
    "url": "https://github.com/dropbox/app-store-server-library-python",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Python",
        "color": "#3572A5"
      },
      {
        "name": "Lua",
        "color": "#000080"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "R_kgDOP7QVbQ",
    "name": "pull-request-comment-branch",
    "description": "A GitHub Action to get the head ref and sha of a pull request comment",
    "stargazerCount": 0,
    "forkCount": 0,
    "url": "https://github.com/dropbox/pull-request-comment-branch",
    "homepageUrl": "",
    "languages": [
      {
        "name": "TypeScript",
        "color": "#3178c6"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "R_kgDOP7QV1w",
    "name": "set-commit-status-action",
    "description": "GitHub Action to set commit status",
    "stargazerCount": 0,
    "forkCount": 0,
    "url": "https://github.com/dropbox/set-commit-status-action",
    "homepageUrl": "",
    "languages": [
      {
        "name": "JavaScript",
        "color": "#f1e05a"
      },
      {
        "name": "TypeScript",
        "color": "#3178c6"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  },
  {
    "id": "R_kgDOP-Lykw",
    "name": "mcp-server-dash",
    "description": "Dropbox Dash MCP Server",
    "stargazerCount": 6,
    "forkCount": 4,
    "url": "https://github.com/dropbox/mcp-server-dash",
    "homepageUrl": "",
    "languages": [
      {
        "name": "Makefile",
        "color": "#427819"
      },
      {
        "name": "Python",
        "color": "#3572A5"
      }
    ],
    "contributors": [],
    "topics": [],
    "owner": "dropbox"
  }
]